import RoomClient from "components/containers/utils/mediaSoup/RoomClient";
import { userInfoMapperSocket } from "components/containers/utils/sockets/userInfoMapperSocket";
import { socketContextType } from "index";
import { User } from "models/User";
import { useContext, useEffect, useMemo, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import SocketContext from "socket-context";
import { RootState } from "store";
import { rolePlayModalType, rolePlaySubType, socketMessageSubType, socketMessageType, socketSteps } from "types/Constants";
import BottomMessageWithIcon from "../Group_Discussion/BottomMessageWithIcon";
import * as Dialog from '@radix-ui/react-dialog';
import RoleplaySwapModal from "./RolePlaySwapModal";
import { validateAndCreateSocketIfExist } from "utils/SocketValidator";
import { calculatePrivateRoomMuteStates, calculateStageThreeMuteStates, getGroupName, groupBy, isBlankOrNull, parseToJson, userToParticipantConverter } from "utils/StreamingHelperFunctions";
import { Flex, Button, Text, Box } from '@radix-ui/themes';
import PeerView from "components/classroom/components/Peers/PeerView";
import MyPeerView from "components/classroom/components/Peers/MyPeerView";
import Draggable from "react-draggable";
import mico from "../../../assets/images/mico.png";
import plussquare from "../../../assets/images/plussquare.png";
import maximize from "../../../assets/images/maximize.png";
import minus from "../../../assets/images/minus.png";
import roleplay from "../../../assets/images/roleplay.png";
import micoff from "../../../assets/images/micoff.png";
import minimize from "../../../assets/images/minimize.png";
import Trainer from "components/classroom/components/backup/Trainer";
import briefIcons from "../../../assets/images/BriefIcons.png";
import xCircle from "../../../assets/images/XCircle.png";
import backIcon from "../../../assets/images/arrow-left.png";
import TableElement from "components/classroom/components/TableElement";
import TableElementNew from "components/classroom/components/TableElementNew";
import { nominationType } from "../Group_Discussion/GroupDiscussion";
import RoleplayModal from "./RolePlayModal";
import RpSetup from "./popup/RpSetup";
import RpReadyToPresent from "./popup/RpReadyToPresent";
import RpStartPresenter from "./popup/RpStartPresenter";
import RpEndWait from "./popup/RpEndWait";
import RpCompletePreparation from "./popup/RpCompletePreparation";
import RpWait from "./popup/RpWait";
import RpCommence from "./popup/RpCommence";
import RpNominateGroupleader from "./popup/RpNominateGroupLeader";
import RpRandomlySelected from "./popup/RpRandomlySelected";
import RpPresentationRankOrder from "./popup/RpPresentationRankOrder";
import RpOpenClassInteraction from "./popup/RpOpenClassInteraction";
import { UserInfoMapperSocketHandler } from "utils/UserInfoMapper";
import ParticipantNew from "components/classroom/components/backup/ParticipantNew";
import OpenClassInteraction from "components/classroom/components/backup/OpenClassInteraction";
import { updateLiveStreamSettings, updateSessionSettings } from "store/reducers/livestreamSettings";
import { debounce } from "lodash";
// import { usePrivateRoomAudio } from "hooks/usePrivateRoomAudio";
interface rdProps {
    roomClient?: RoomClient | null;
    messageCount: any;
    showPresentModal?: () => void;
    onBrief: (val: any) => void,
    activityData: any;
    showPresentButton: boolean;
    consoleDetailData: any
};

export enum RolePlayLaunchedType {
    ClosedRolePlay = 1,
    OpenRolePlay = 2,
    InstantVerbalBriefRolePlay = 3,
}

// const RolePlay = ()=>{
//     return <></>
// }

// const AllAudioConsumers: React.FC<any> = ({
//     consumers,
//     privateRoomData,
//     rpUsers,
//     currentDebriefedEmail,
// }) => {
//     const audioRefs = useRef<{ [key: string]: HTMLAudioElement | null }>({});
//     const profileData = useSelector((state: any) => state.auth.user);
//     const mountedTracks = useRef<{ [key: string]: boolean }>({});

//     // Filter only live audio tracks
//     let audioConsumers = consumers?.filter(
//         (c) => (c.track?.kind || c.kind) === "audio" && c.track?.readyState === "live"
//     );
//     console.log('audioConsumers bye', audioConsumers);


//     const peerIds = audioConsumers?.map((c) => c.peerId) || [];

//     const { muteStates } = usePrivateRoomAudio({
//         peerIds,
//         profileData,
//         rpUsers,
//         currentDebriefedEmail,
//     });

//     console.log("muteStates bye", muteStates);

//     useEffect(() => {
//         audioConsumers?.forEach((consumer) => {
//             const audioEl = audioRefs.current[consumer.id];
//             if (audioEl && consumer.track && !mountedTracks.current[consumer.id]) {
//                 const mediaStream = new MediaStream([consumer.track]);
//                 audioEl.srcObject = mediaStream;
//                 audioEl
//                     .play()
//                     .catch((e) => console.log("Audio play error:", e));
//                 mountedTracks.current[consumer.id] = true; // mark as mounted
//             }
//         });
//     }, [audioConsumers]);

//     // Update mute dynamically without touching srcObject
//     useEffect(() => {
//         audioConsumers?.forEach((consumer) => {
//             const audioEl = audioRefs.current[consumer.id];
//             if (audioEl) {
//                 audioEl.muted = !!muteStates[consumer.peerId];
//             }
//         });
//     }, [audioConsumers, muteStates]);


//     return (
//         <>
//             {audioConsumers?.map((consumer) => (
//                 <audio
//                     key={consumer.id}
//                     ref={(el) => (audioRefs.current[consumer.id] = el)}
//                     playsInline
//                     autoPlay
//                 />
//             ))}
//         </>
//     );
// };


const RolePlay = ({ roomClient, activityData, consoleDetailData, messageCount, onBrief, showPresentModal, showPresentButton }: rdProps) => {
    const dispatch = useDispatch();
    const session_id = useSelector((state: RootState) => state?.live.settings.roomId)
    const [amImute, setAmImute] = useState(false);
    const profileData = useSelector((state: RootState) => state?.auth?.user as User);
    const batchData = useSelector((state: RootState) => state.live.settings?.batch);
    const settings = useSelector((state: RootState) => state.live.settings);
    let userInfoHandler = useRef<UserInfoMapperSocketHandler>();
    const socketList: socketContextType[] = useContext(SocketContext);
    const consumers = useSelector((state: RootState) => state.live.settings.consumers);
    const producers = useSelector((state: RootState) => state.live.settings.producers);
    const rpSelectedTraineeForPresentation = useSelector((state: any) => state.countReducer?.rpSelectedTraineeForPresentation);
    const dropoutState = useSelector((state: any) => state.countReducer?.response);
    const { batch, mode } = useSelector((state: RootState) => state.live.settings);
    const tables = batch ? JSON.parse(batch?.sittingStyle[0].table) : [];


    const [isPreRecorded, setIsPreRecorded] = useState(false)
    const [layoutHeight, setLayoutHeight] = useState(0);
    const [boxSize, setBoxSize] = useState({ height: 0, width: 0 });
    const [showRoleplayModal, setShowRoleplayModal] = useState(false);
    const [rpMode, setRpMode] = useState<any>(rolePlayModalType.YOU_VOLUNTEER);
    const [rpUsers, setRpUsers] = useState([]);
    const [closedBrief, setClosedBrief] = useState(false);
    const [showRoleName, setShowRoleName] = useState(true)
    const [roleplayAnalysisEnded, setRoleplayAnalysisEnded] = useState(false)
    const [showRpSwapModal, setShowRpSwapModal] = useState(false);
    const [roleSystemSelect, setRoleSystemSelect] = useState(false);
    const [isBriefing, setIsBriefing] = useState(false);
    const [openPrivatRoom, setOpenPrivatRoom] = useState(false);
    const [shouldShowOpenPrivatRoom, setShouldShowOpenPrivatRoom] = useState(false);
    const [shouldShowisRoleplayLaunched, setShouldShowisRoleplayLaunched] = useState(false);
    const [privateRoomData, setPrivateRoomData] = useState<any>({});
    const [privateRoomUsers, setPrivateRoomUsers] = useState([]);
    const [activity_data, setActivity_data] = useState<any>({});
    const [openClassInteraction, setOpenClassInteraction] = useState(false)
    const [selectedIndex, setSelectedIndex] = useState(-1);
    const [tblData, setTblData] = useState<any>({});
    const [tblDataSnap, setTblDataSnap] = useState<any>({});
    const [groupleader, setGroupleader] = useState<{ participant_email: string }>(undefined);
    const [groupOrder, setGroupOrder] = useState<any>([]);
    const [briefMode, setBriefMode] = useState<string>("");
    const [canTransfer, setCanTransfer] = useState(true)
    const [fileToPresent, setFileToPresent] = useState('');
    const [presentaionType, setPresentaionType] = useState('')
    const [shareStream, setShareStream] = useState({ toURL: () => { } });
    const [modalVisible, setModalVisible] = useState(false);
    const [myEmailInPresentation, setMyEmailInPresentation] = useState({ participant_email: "no email" });
    const [rpOngoing, setRpOnging] = useState(false);
    const [myStream, setMyStream] = useState<any>({});
    const [otherStream, setOtherStream] = useState<any>({});
    const [allStream, setAllStream] = useState<any>({});
    const [unMuteParticipant, setUnMuteParticipant] = useState<any>({});

    const [showStartPresentation, setShowStartPresentation] = useState(false)
    const [isPresentationStarted, setIsPresentationStarted] = useState(false)
    const [presentaionData, setPresentaionData] = useState<any>({})
    const [showMenu, setShowMenu] = useState(false)
    const [showFullscreen, setShowFullscreen] = useState(false)

    const [randomlySelected, setRandomlySelected] = useState({})
    const [GLMmode, setGLMmode] = useState<string>('')
    const [isGlTransfer, setIsGlTransfer] = useState(false)
    const [isRolePlayAccepted, setIsRolePlayAccepted] = useState(false);
    const [isExpandedTabel, setIsExpandedTabel] = useState(false);
    const [isUsersDragableCompOpen, setIsUsersDragableCompOpen] = useState(true);
    const [isRenderPrgoress, setIsRenderPrgoress] = useState(true)
    const [timeExtended, setTimeExtended] = useState(false)
    const [manuallySelected, setmanuallySelected] = useState<any>()
    const [presenterTimer, setPresenterTimer] = useState<boolean>(false)
    const [preTimer, setPreTimer] = useState<any>()
    const [newUsers, setNewUsers] = useState()
    const [rolePlaySystemSelect, setRolePlaySystemSelect] = useState(false)
    const [otherClicked, setOtherClicked] = useState(false)
    const [presentationOrder, setPresentationOrder] = useState<any>({
        groupName: '',
        rankOrder: '',
        traineeDetails: {},
        isOurGroupIsGoingToRepresent: false,
        presenterGroup: {},
    })
    const [minutes, setMinutes] = useState(0);
    const [timeLeft, setTimeLeft] = useState(null);
    const [isTwoMinutesLeft, setIsTwoMinutesLeft] = useState(false);

    const [isIamRepresentingGroup, setIsIamRepresentingGroup] = useState(false);
    const [hardCopyModifiedGroupTableData, setHardCopyModifiedGroupTableData] = useState({});
    const [hideOurDraggableView, setHideOurDraggableView] = useState(false)
    const [removedEmail, setRemovedEmail] = useState('');
    const [mute, setMute] = useState(false);
    const [messageCxt, setMessageCxt] = useState<{ visible: boolean, message: string }>({ visible: false, message: '' })
    const [countdown, setCountdown] = useState(10);
    const mainLayoutRef = useRef(null);
    let timer: any;
    const tblDataRef = useRef<any>();
    tblDataRef.current = tblData;
    const [spotlightTable, setSpotlightTable] = useState({})
    const socketMessageSubTypeRef = useRef<any>();

    const groupleaderRef = useRef<any>();
    groupleaderRef.current = groupleader;

    const [roleplayLaunched, setRoleplayLaunched] = useState(false);
    //   const shareConsumer = useSelector(memoize((state: any) => selectShareConsumer(state)));
    const allGroup = useSelector((state: any) => state?.session?.allGroup);
    const { trainer } = useSelector((state: RootState) => state.live.settings);
    let blinkingAnimation: any;
    // const opacityValue = useRef(new Animated.Value(1)).current;
    const opacityValue = 1;
    const [isBlinking, setIsBlinking] = useState(true);
    const [showBriefModal, setShowBriefModal] = useState(false);// Keep these state declarations
    const [rpData, setRpData] = useState<any>(null);
    const [accessBriefCondition, setAccessBriefCondition] = useState(false);
    const [rpActivityData, setRpActivityData] = useState<any>(null);

    const accessBrief = useMemo(() => {
        const rolePlayersList = rpUsers || rpData;
        if (!rolePlayersList || rolePlayersList.length === 0) {
            return false;
        }

        const isUserInRp = rolePlayersList.some(
            (user) => user.userEmail === profileData?.email
        );

        // For all role play types, if share condition is true, everyone can access
        if (accessBriefCondition) {
            return true;
        }

        // If share condition is false, only role players can access
        return isUserInRp;
    }, [rpUsers, rpData, accessBriefCondition, profileData?.email, rpActivityData]);

    const processedStreams = useMemo(() => {
        return allStream;
    }, [JSON.stringify(Object.keys(allStream))]);

    let userMicState = useSelector((state: any) => state.countReducer?.micState);
    useEffect(() => {
        if (profileData?.email) {
            if (userMicState === 'unsupported') {
                // on
                setAmImute(true)
            }
            if (userMicState === 'on') {
                // off
                setAmImute(false)
            }
        }
    }, [userMicState])

    useEffect(() => {
        userInfoHandler.current = validateAndCreateSocketIfExist(session_id, handleOnMessage, socketList);
    }, []);

    // useEffect(() => {
    //     if (dropoutState) {
    //         processSocketEvents(dropoutState);
    //     }
    // }, [dropoutState]);


    useEffect(() => {
        if (!roleSystemSelect) return;

        const timer = setInterval(() => {
            setCountdown(prevCountdown => {
                if (prevCountdown === 1) {
                    setRoleSystemSelect(false)
                    setOtherClicked(true)
                    setTimeout(() => {
                        setOtherClicked(false)
                    }, 2000);
                    return 10; // Reset to 10 when it reaches 0
                } else {
                    return prevCountdown - 1;
                }
            });
        }, 1000);

        return () => clearInterval(timer);
    }, [roleSystemSelect]);

    useEffect(() => {
        // set the brief URL here so that user can access from 3 dots
        console.log('activityData.activity_data', activityData)
        const actData = parseToJson(activityData.activity_data);
        let brief: { url: string }[] = [];
        if (actData?.types_of_role_play == 2 || actData?.types_of_role_play == 4) {
            // Pre-recorded role, open role play in this case there will be single document
            // @ts-ignore
            brief.push({ attachment_url: actData?.role_brief_url || actData?.brief_verbal });
        } else {
            actData?.roles?.forEach((role: any) => {
                if (!isBlankOrNull(role.attachment_url)) {
                    // @ts-ignore
                    brief.push({ attachment_url: role.attachment_url });
                }
            });
        }
        // props.onBrief(brief);
    }, [activityData])

    useEffect(() => {
        if (timeLeft === null) return;
        const interval = setInterval(() => {
            setTimeLeft(prevTime => {
                // console.log('Interval:::', prevTime, isTwoMinutesLeft);
                if (Number(prevTime) <= 0) {
                    clearInterval(interval);
                    return null;
                }
                if (Number(prevTime) == 120) {
                    console.log('setting true')
                    setIsTwoMinutesLeft(true);
                }
                return Number(prevTime) - 1;
            });
        }, 1000);

        return () => clearInterval(interval);
    }, [timeLeft]);

    useEffect(() => {
        if (isTwoMinutesLeft === false) {
            return
        } else {
            setTimeout(() => {
                setIsTwoMinutesLeft(false)
            }, 3000);
        }
    }, [isTwoMinutesLeft])


    useEffect(() => {
        const debouncedUpdate = debounce(() => {
            if (openPrivatRoom && privateRoomUsers?.length > 0 && !shouldShowOpenPrivatRoom) {
                const audioConsumers = Object.values(consumers)?.filter(
                    (c) => (c.track?.kind || c.kind) === "audio" && c.track?.readyState === "live"
                );
                const peerIds = audioConsumers?.map((c) => c.peerId) || [];
                const currentDebriefedEmail = privateRoomUsers[0]?.userEmail || null;
                const { muteStates } = calculatePrivateRoomMuteStates({
                    peerIds,
                    profileData,
                    rpUsers,
                    currentDebriefedEmail,
                });
                roomClient.consumerPauseByMuteStates(muteStates);
                setShouldShowOpenPrivatRoom(true);
            }
        }, 100);
        debouncedUpdate();
        return () => debouncedUpdate.cancel();
    }, [openPrivatRoom, privateRoomUsers]);

    useEffect(() => {
        if (isBriefing && rpUsers.length > 0) {
            roomClient.consumerResumeAllAudio();
        }
    }, [isBriefing, rpUsers]);

    useEffect(() => {
        if (roleplayAnalysisEnded) {
            roomClient.consumerResumeAllAudio();
        }
    }, [roleplayAnalysisEnded])

    useEffect(() => {
        const debouncedUpdate = debounce(() => {
            if (roleplayLaunched && rpUsers.length > 0) {
                const audioConsumers = Object.values(consumers)?.filter(
                    (c) => (c.track?.kind || c.kind) === "audio" && c.track?.readyState === "live"
                );
                const peerIds = audioConsumers?.map((c) => c.peerId) || [];
                const { muteStates } = calculateStageThreeMuteStates({
                    peerIds,
                    profileData,
                    rpUsers,
                    tables
                });
                console.log('muteStates: bye', muteStates);
                roomClient.consumerResumeRoleplayersAudio(muteStates);
                // setShouldShowisRoleplayLaunched(true);
            }
        }, 100);
        debouncedUpdate();
        return () => debouncedUpdate.cancel();
    }, [roleplayLaunched, rpUsers]);
    //   useEffect(() => {
    //     addShareTrack().then((res) => {
    //       if (res) {
    //         setShareStream(res)
    //       } else {
    //         setShareStream({ toURL: () => { } });
    //       }
    //     });
    //   }, [shareConsumer]);


    useEffect(() => {
        if (activityData?.activity_data) {
            setActivity_data(parseToJson(activityData?.activity_data))
        }
    }, [activityData?.activity_data])

    // getting group from batch data
    useEffect(() => {
        if (allGroup && allGroup?.length > 0) {
            getTableName(allGroup)
        }
        else {
            if (batchData && batchData?.sittingStyle?.length > 0) {
                if (batchData?.sittingStyle && batchData?.sittingStyle[0] && batchData?.sittingStyle[0]?.table && !batchData?.sittingStyle[0]?.assign_manually) {
                    // console.log('*** system assign ***')
                    getTableName(parseToJson(batchData?.sittingStyle[0]?.table))
                }
                else {
                    // console.log('*** manually assign ***');
                    getTableName(parseToJson(batchData?.sittingStyle[0]?.table))
                }
            }
        }
    }, [batchData])

    useEffect(() => {
        const producersArray = Object.values(producers);

        const videoProducer: any = producersArray?.find(
            (producer: any) =>
                producer.kind === "video"
        );
        if (videoProducer) {
            const stream = new MediaStream();
            stream.addTrack(videoProducer.track);
            setMyStream(prev => {
                const newStream = { [profileData?.email]: stream };
                return JSON.stringify(prev) === JSON.stringify(newStream) ? prev : newStream;
            });
        } else {
            setMyStream(prev => {
                const newStream = { [profileData?.email]: { toURL: () => { } } };
                return JSON.stringify(prev) === JSON.stringify(newStream) ? prev : newStream;
            });
        }
    }, [producers]);

    useEffect(() => {
        if (consumers) {
            let _consumers = Object?.values(consumers);
            let newConsumerArray = groupBy(_consumers, "peerId");
            let _newConsumerArray = Object.values(newConsumerArray);
            let origianlStreamArray: any;
            _newConsumerArray &&
                _newConsumerArray?.map((c: any, i: number) => {
                    let stream = new MediaStream();
                    let peerId: any;
                    c?.map((c1: any, i1: number) => {
                        stream?.addTrack(c1?.track);
                        peerId = c1?.peerId;
                    });
                    
                    if (!origianlStreamArray || !origianlStreamArray[peerId] || origianlStreamArray[peerId] !== stream) {
                        origianlStreamArray = { ...origianlStreamArray, [peerId]: stream };
                    }
                });
                
            if (origianlStreamArray) {
                setOtherStream(prev => {
                    const hasChanged = JSON.stringify(prev) !== JSON.stringify(origianlStreamArray);
                    return hasChanged ? origianlStreamArray : prev;
                });
            }
        }
    }, [consumers]);

    useEffect(() => {
        setAllStream(prev => {
            const newStream = { ...otherStream, ...myStream };
            const hasChanged = JSON.stringify(prev) !== JSON.stringify(newStream);
            return hasChanged ? newStream : prev;
        });
    }, [otherStream, myStream]);

    useEffect(() => {
        if (manuallySelected) {
            const myEmailInPresentations = manuallySelected?.seats.find((item: any) => item.participant_email === profileData?.email)
            setMyEmailInPresentation(myEmailInPresentations)
        }
        if (rpMode !== 'SHOW_RANK_ORDER_FOR_PRESENTATION') {
            setRpMode('SELECTION_OF_GROUP_REPRESENTATION_BY_PARTICIPANTS');
        }
    }, [manuallySelected]);

    useEffect(() => {
        if (rpMode === 'WHEN_GROUP_IS_PRESENTING') {
            roomClient.consumerResumeAllAudio();
        } else if (rpMode === 'SELECTION_OF_GROUP_REPRESENTATION_BY_PARTICIPANTS' && manuallySelected) {
            console.log('manuallySelected bye', manuallySelected);

            roomClient.consumerMuteParticipantByGroup(manuallySelected, 'trainer@vtt');
        }
    }, [rpMode])

    useEffect(() => {
        const debouncedUpdate = debounce(() => {
            console.log('manuallySelected bye', manuallySelected);
            console.log('myEmailInPresentation bye', myEmailInPresentation);

            if (rpMode === 'SELECTION_OF_GROUP_REPRESENTATION_BY_PARTICIPANTS' && manuallySelected) {
                if (myEmailInPresentation?.participant_email === profileData?.email) {
                    roomClient?.consumerMuteParticipantByGroup(manuallySelected, 'trainer@vtt');
                }
            }
        }, 100);
        debouncedUpdate();
        return () => debouncedUpdate.cancel();
    }, [rpMode, manuallySelected]);

    const processSocketEvents = async (dropoutState: any) => {
        if (!dropoutState || !dropoutState.socketEvents) {
            console.error('processSocketEvents: dropoutState is undefined, invalid, or socketEvents is missing');
            return;
        }
        try {
            //   dispatch(storeResponse(dropoutState));
            if (Array.isArray(dropoutState.socketEvents)) {
                for (let i = 0; i < dropoutState.socketEvents.length; i++) {
                    const event = dropoutState.socketEvents[i];
                    console.log(`--- Starting event #${i} ---`);
                    try {
                        await handleOnMessage(event.message);
                        // Wait for 1 second so the UI can update and user can see the change
                        await new Promise(resolve => setTimeout(resolve, 1000));
                        console.log(`✓ Finished event #${i}`);
                    } catch (e) {
                        console.error(`✗ Error in event #${i}:`, e);
                    }
                }
            } else {
                console.log("No socketEvents found in the response or socketEvents is not an array.");
            }

        } catch (error) {
            console.error("Error in processSocketEvents:", error);
        }
    };

    const onPreparationComplete = () => {
        setRpMode(undefined)
        setShowStartPresentation(true)
    }


    const updateSessionMetaInfo = () => {
        let objBody = {
            sessionSegmanetId: session_id,
            type: 'VOLUNTEERING',
            traineeList: [profileData?.id]
        };
        console.log("objBody ->", objBody)
        // postDataWithToken(objBody, mobile_siteConfig.MOB_UPDATE_SESSION_META_INFO)
        //   .then((res: any) => {
        //     const { response } = res;
        //     if (response.data && typeof response.data == 'object') { } else { }
        //   })
        //   .catch((error: any) => { console.log(error) });
    }

    const getTableName = async (data: any, showModal: boolean = false) => {
        data?.forEach((tableData: any, i: any) => {
            tableData?.seats?.map((v1: any, i1: any) => {
                let item = userToParticipantConverter(v1);
                // assign the updated value.
                tableData.seats[i1] = item;
                if (item?.participant_email?.toLowerCase() == profileData?.email?.toLowerCase()) {
                    setTblDataSnap(tableData)
                    setTblData(tableData);
                    getGroupLeader(tableData, showModal);
                }
            });
        });
    };

    const inExistingGroup = (tables: any[]) => {
        if (tables?.length > 0) {
            getTableName(tables)
        }
    }

    const getGroupLeader = (v: any, showModal: boolean = false) => {
        let gl = v?.seats?.find((e: any) => e?.group_leader)
        setGroupleader(gl);
        if (showModal && gl?.participant_name) {
            if (gl?.participant_email == profileData?.email) {
                setCanTransfer(false)
                setRpMode(rolePlayModalType?.YOUSELECTEDGL)
            }
            else {
                setRandomlySelected(gl?.participant_name)
                setRpMode(rolePlayModalType?.RANDOMLYSELECTED)
            }
        }
    };

    const selectVolunteerFirst = () => {
        if (!userInfoHandler.current) {
            userInfoHandler.current = validateAndCreateSocketIfExist(session_id, handleOnMessage, socketList);
        }
        let group_leader = groupleader && Object.keys(groupleader).length > 0 ? true : false;
        let user_data = {
            userEmail: profileData?.email,
            userName: profileData?.email,
            seatingPlan: tblData,
            groupLeader: group_leader,
            timeStamp: Date.now(),
        };
        userInfoHandler.current.sendMessage(
            JSON.stringify({
                sub_type: 'system_request_accepted',
                type: 'role_play',
                user_data: user_data,
                room_id: session_id,
            })
        );
        setRpMode(rolePlayModalType.NOMINATEPRESENTER);
    };

    const startPresentation = () => {
        let payload = {
            sub_type: rolePlaySubType?.LAUNCH_PRESENTATION_SCREEN,
            type: socketMessageType?.ROLE_PLAY,
            room_id: session_id,
            activityData: {
                activePresentation: presentaionType,
                fileUrl: fileToPresent,
                presentNominee: profileData?.email,
                myGroups: tblDataRef?.current?.seats
            }
        }
        if (presentaionType == 'share_screen') {
            roomClient.enableShare() // share user's screen
        }
        setShowStartPresentation(false);
        if (!userInfoHandler.current) {
            userInfoHandler.current = validateAndCreateSocketIfExist(session_id, handleOnMessage, socketList);
        }
        userInfoHandler.current.sendMessage(JSON.stringify(payload));
    }

    const renderVideoPlayer = () => {
        return (
            <div className="w-full">
                <video
                    src={activity_data?.role_brief_url}
                    className="w-full h-[50vh] object-contain"
                    autoPlay
                    muted={false}
                    controls
                />
            </div>
        );
    };

    const ConditionalRoleBrief = ({
        accessBrief,
        rpData,
        roleName,
        activityData
    }) => {

        // Early returns for invalid states
        if (!accessBrief) {
            return null;
        }

        if (!rpData || !Array.isArray(rpData) || rpData.length === 0) {
            return null;
        }

        if (!activityData) {
            return null;
        }

        const filteredRole = rpData.find(item => item.role_name === roleName);

        if (!filteredRole) {
            return null;
        }

        // Get role play type and share condition from activity data
        const rolePlayType = activityData.types_of_role_play;
        const shareCondition = activityData.share_brief;

        // Check if current user is a role player
        const isCurrentUserRolePlayer = rpUsers?.some(
            user => user.userEmail === profileData?.email
        );
        const currentUserRole = rpUsers?.find(
            user => user.userEmail === profileData?.email
        );
        const isCurrentUsersRole = currentUserRole?.role_name === roleName;

        // Apply visibility logic based on the rules
        let shouldShowBrief = false;

        switch (rolePlayType) {
            case RolePlayLaunchedType.OpenRolePlay: // Open role play = 2
                if (shareCondition) {
                    // Every rp user can see every other rp user, All "others" can see every rp user
                    shouldShowBrief = true;
                } else {
                    //Every rp user can see every other rp user, "Others" cannot see any rp user
                    shouldShowBrief = isCurrentUserRolePlayer;
                }
                break;

           case RolePlayLaunchedType.ClosedRolePlay: // Closed role play = 1
            if (shareCondition) {
                // rp users cannot see each other, All "others" can see all rp users
                shouldShowBrief = (!isCurrentUserRolePlayer) || (isCurrentUserRolePlayer && isCurrentUsersRole);
            } else {
                // rp users cannot see each other, "Others" cannot see any rp user
                shouldShowBrief = isCurrentUserRolePlayer && isCurrentUsersRole;
            }
            break;

            case RolePlayLaunchedType.InstantVerbalBriefRolePlay: // Instant verbal brief = 3
                    shouldShowBrief = false;
                break;

            default:
                shouldShowBrief = false;
        }

        if (!shouldShowBrief) {
            return null;
        }

        return (
            <ViewRoleBriefButton
                v={filteredRole}
                activityData={activityData}
            />
        );
    };

    const BlinkingView = () => {
        let _briefToDisplay = [];
        let _rpBriefUser = rpUsers.filter(
            (x) => x?.userEmail?.toLowerCase() === profileData?.email?.toLowerCase()
        );
        if (_rpBriefUser?.length > 0) {
            _briefToDisplay = _rpBriefUser;
        } else {
            _briefToDisplay = activity_data?.roles;
        }
        let attechmentArray = _briefToDisplay?.filter((x) => x?.attachment_url) || [];
        let isEmpty = attechmentArray?.length < 1;

        // if (isEmpty) {
        //   return <div className="w-[11vh]" />;
        // }

        return (
            <div>
                <div
                    className={`flex justify-end ${isBlinking ? 'animate-pulse' : ''}`}
                    style={{ opacity: isBlinking ? opacityValue : 1 }}
                >
                    <button
                        onClick={() => {
                            if (rpUsers?.length > 0) {
                                setIsBlinking(false);
                            }
                        }}
                        className="rounded-lg"
                    >
                        <img
                            src={briefIcons}
                            alt="Brief Icon"
                            className="h-[2vh] w-[2vh] object-contain"
                        />
                    </button>
                </div>

                <Dialog.Root open={showBriefModal} onOpenChange={setShowBriefModal}>
                    <Dialog.Portal>
                        <Dialog.Overlay className="fixed inset-0 bg-black bg-opacity-50 transition-opacity" />
                        <Dialog.Content className="fixed top-[16.5vh] left-0 w-full bg-white p-4">
                            <div className="flex items-center">
                                <button
                                    onClick={() => setShowBriefModal(false)}
                                    className="h-[3vh] w-[4vh] m-[1.5vh]"
                                >
                                    <img
                                        src={backIcon}
                                        alt="Back"
                                        className="h-full w-full object-contain"
                                    />
                                </button>
                                <Text
                                    as="span"
                                    size="4"
                                    weight="bold"
                                    className="text-black font-[Lato-Bold]"
                                >
                                    Brief
                                </Text>
                            </div>
                            <div>
                                {attechmentArray.map((item, index) => (
                                    <div key={index}>
                                        {item?.attachment_url.endsWith('.pdf') ? (
                                            // <PdfViewer url={item?.attachment_url} />
                                            <></>
                                        ) : (
                                            <iframe
                                                src={`https://view.officeapps.live.com/op/embed.aspx?src=${item?.attachment_url}`}
                                                className="w-full h-[80vh]"
                                                title="Office Document"
                                            />
                                        )}
                                    </div>
                                ))}
                            </div>
                        </Dialog.Content>
                    </Dialog.Portal>
                </Dialog.Root>
            </div>
        );
    };

    const ViewRoleBriefButton = ({ v, activityData }) => {
        return (
            <button
                onClick={() => briefClick({ v, activityData })}
                className="absolute left-2 top-5 z-[999999] bg-[rgba(33,32,37,0.7)]  flex justify-center items-center p-1"
            >
                <BlinkingView />
            </button>
        );
    };

    const briefClick = ({ v, activityData }) => {
        if (v?.attachment_url) {
            onBrief({ ...v, activityData });
        }
    };

    const renderPrivateRoom = () => {
        if (privateRoomUsers?.length > 0) {
            console.log('privateRoomUsers', privateRoomUsers);

            if (privateRoomUsers.length <= 2) {
                return (
                    <div className="flex flex-col h-full w-full">
                        {privateRoomUsers.map((v, i) => (
                            <div key={i}>
                                {/* <div
                                    className="bg-[rgba(33,32,37,0.8)] w-[70%] rounded-xl h-[30px] flex items-center justify-center absolute"
                                >
                                    <div className="flex items-center space-x-2 absolute left-[4vh]">
                                        <Text
                                            as="span"
                                            size="2"
                                            className="text-[#E9BE50] text-center font-[Lato-Regular]"
                                        >
                                            Role Player’s briefing in progress
                                        </Text>
                                        <div
                                            className="bg-green-500 border-[1.5px] border-[#E9BE50] h-[1.5vh] w-[1.5vh] rounded-full ml-[3%]"
                                        />
                                    </div>
                                </div> */}
                                {/* <div
                                    className="bg-[rgba(33,32,37,0.8)] w-[70%] rounded-xl h-[30px] flex items-center justify-center relative"
                                >
                                    <div className="flex items-center space-x-2 absolute left-[5vh]">
                                        <Text
                                            as="span"
                                            size="2"
                                            className="text-[#E9BE50] text-center font-[Lato-Regular]"
                                        >
                                        </Text>
                                        <div
                                            className="bg-green-500 border-[1.5px] border-[#E9BE50] h-[1.5vh] w-[1.5vh] rounded-full ml-[3%]"
                                        />
                                    </div>
                                </div> */}
                                <div className="flex-1 relative">
                                    <div className="flex mobile:flex-col flex-row h-full gap-1 tablet:grid-cols-1 mobile:grid-cols-1 grid grid-cols-2 mobile:gap-4">
                                        <div className="relative">
                                            <Trainer isAudio={false} peerMode={true} videoHeight={290} videoWidth={'100%'} name={trainer?.fullname} trainerTableName="On Table 1" />
                                            <div className="absolute mobile:w-3/2 w-1/2  left-2 bottom-4 bg-[rgba(36,39,44,0.6)] rounded-md p-2">
                                                <div className="flex items-center justify-between">
                                                    {/* LEFT: Name + Role */}
                                                    <div className="flex flex-col items-start justify-center">
                                                        <Text
                                                            as="span"
                                                            size="2"
                                                            className="text-white font-[Lato-Regular] text-left"
                                                        >
                                                            {trainer?.fullname}
                                                        </Text>
                                                        <Text
                                                            as="span"
                                                            size="2"
                                                            className="text-white font-[Lato-Regular] text-left"
                                                            style={{ fontWeight: 400, fontSize: '14px', color: '#E9BE50' }}
                                                        >
                                                            Trainer
                                                        </Text>
                                                    </div>

                                                    {/* RIGHT: SVG inside black circle */}
                                                    <div className="flex items-center justify-center rounded-full bg-black p-2 ml-3">
                                                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                                                            <path d="M15.8284 5.80847C14.4012 5.0875 12.8004 4.70644 11.199 4.70644C11.1986 4.70644 11.1981 4.70644 11.1977 4.70644C10.6648 4.7065 10.1318 4.74903 9.60509 4.83198V1.37988C9.60509 1.26197 9.53872 1.15408 9.4335 1.10092C8.43169 0.594912 7.36006 0.258416 6.24831 0.100809C6.07766 0.0764943 5.91928 0.195473 5.89503 0.366362C5.87084 0.537251 5.98969 0.695451 6.16059 0.719672C7.14141 0.858746 8.08894 1.14602 8.98009 1.57431V4.95008C8.14388 5.13491 7.33056 5.42306 6.56666 5.8084C6.46134 5.86153 6.39491 5.96948 6.39491 6.08746V6.54287C6.37419 6.52077 6.35322 6.49887 6.3315 6.47752C5.92059 6.07389 5.37703 5.85162 4.80094 5.85162C4.22484 5.85162 3.68131 6.07389 3.27038 6.47752C2.86009 6.88049 2.62791 7.41888 2.61659 7.99346C2.61431 8.11034 2.67741 8.21873 2.78016 8.27442C2.883 8.33014 3.00822 8.32377 3.10484 8.25801C3.60591 7.91695 4.19241 7.73669 4.80091 7.73669C5.36859 7.73669 5.917 7.8937 6.39488 8.19163V10.0498C5.90137 10.3397 5.36681 10.5453 4.80253 10.6615C2.37825 10.1618 0.625 8.01537 0.625 5.53454V1.5744C1.51606 1.14671 2.46309 0.85959 3.443 0.720266C3.61388 0.695983 3.73272 0.537751 3.70841 0.366862C3.68412 0.195973 3.52566 0.0771818 3.35503 0.101434C2.24441 0.259353 1.17341 0.595599 0.171781 1.10083C0.0664375 1.15399 0 1.2619 0 1.37988V5.53454C0 8.33433 1.99472 10.7536 4.743 11.287C4.76266 11.2908 4.78263 11.2927 4.80253 11.2927C4.82244 11.2927 4.84241 11.2908 4.86206 11.287C5.40722 11.1812 5.92822 11.0011 6.41703 10.7506C6.64153 13.3304 8.5575 15.4937 11.1379 15.9946C11.1575 15.9984 11.1775 16.0003 11.1974 16.0003C11.2173 16.0003 11.2373 15.9984 11.2569 15.9946C14.0053 15.4611 16 13.0418 16 10.242V6.08743C16 5.96951 15.9336 5.86163 15.8284 5.80847ZM4.80094 7.1116C4.30722 7.1116 3.82538 7.20999 3.37872 7.39963C3.62459 6.85711 4.17291 6.47661 4.80094 6.47661C5.42897 6.47661 5.97728 6.85708 6.22316 7.39963C5.7765 7.20999 5.29466 7.1116 4.80094 7.1116ZM15.375 10.242C15.375 12.7229 13.6217 14.8693 11.1974 15.369C8.77316 14.8693 7.01988 12.7229 7.01988 10.242V6.28197C9.65175 5.01993 12.7467 5.01987 15.375 6.28185V10.242H15.375Z" fill="#E9BE50" />
                                                        </svg>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="relative">
                                            <PeerView
                                                key={`private-${v?.userEmail}`}
                                                caller="renderPrivateRoom"
                                                userDatax={privateRoomUsers}
                                                logicalMute={true}
                                                style={{ height: 'mobile:h-72', width: '100%' }}
                                                streamURL={processedStreams[v?.userEmail]}
                                                peerEmail={v?.userEmail}
                                            />
                                            <div className="absolute w-1/2 mobile:left-2 mobile:right-auto right-2 bottom-4 bg-[rgba(36,39,44,0.6)] rounded-md p-2">
                                                <div className="flex items-center justify-between">
                                                    {/* LEFT: Name + Role */}
                                                    <div className="flex flex-col items-start justify-center">
                                                        <Text
                                                            as="span"
                                                            size="2"
                                                            className="text-white font-[Lato-Regular] text-left"
                                                        >
                                                            {v?.userName}
                                                        </Text>
                                                        <Text
                                                            as="span"
                                                            size="2"
                                                            className="text-white font-[Lato-Regular] text-left"
                                                            style={{ fontWeight: 400, fontSize: '14px', color: '#E9BE50' }}
                                                        >
                                                            Role: {v?.role_name}
                                                        </Text>
                                                    </div>
                                                    {/* RIGHT: SVG inside black circle */}
                                                    <div className="flex items-center justify-center rounded-full bg-black p-2 ml-3">
                                                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                                                            <path d="M15.8284 5.80847C14.4012 5.0875 12.8004 4.70644 11.199 4.70644C11.1986 4.70644 11.1981 4.70644 11.1977 4.70644C10.6648 4.7065 10.1318 4.74903 9.60509 4.83198V1.37988C9.60509 1.26197 9.53872 1.15408 9.4335 1.10092C8.43169 0.594912 7.36006 0.258416 6.24831 0.100809C6.07766 0.0764943 5.91928 0.195473 5.89503 0.366362C5.87084 0.537251 5.98969 0.695451 6.16059 0.719672C7.14141 0.858746 8.08894 1.14602 8.98009 1.57431V4.95008C8.14388 5.13491 7.33056 5.42306 6.56666 5.8084C6.46134 5.86153 6.39491 5.96948 6.39491 6.08746V6.54287C6.37419 6.52077 6.35322 6.49887 6.3315 6.47752C5.92059 6.07389 5.37703 5.85162 4.80094 5.85162C4.22484 5.85162 3.68131 6.07389 3.27038 6.47752C2.86009 6.88049 2.62791 7.41888 2.61659 7.99346C2.61431 8.11034 2.67741 8.21873 2.78016 8.27442C2.883 8.33014 3.00822 8.32377 3.10484 8.25801C3.60591 7.91695 4.19241 7.73669 4.80091 7.73669C5.36859 7.73669 5.917 7.8937 6.39488 8.19163V10.0498C5.90137 10.3397 5.36681 10.5453 4.80253 10.6615C2.37825 10.1618 0.625 8.01537 0.625 5.53454V1.5744C1.51606 1.14671 2.46309 0.85959 3.443 0.720266C3.61388 0.695983 3.73272 0.537751 3.70841 0.366862C3.68412 0.195973 3.52566 0.0771818 3.35503 0.101434C2.24441 0.259353 1.17341 0.595599 0.171781 1.10083C0.0664375 1.15399 0 1.2619 0 1.37988V5.53454C0 8.33433 1.99472 10.7536 4.743 11.287C4.76266 11.2908 4.78263 11.2927 4.80253 11.2927C4.82244 11.2927 4.84241 11.2908 4.86206 11.287C5.40722 11.1812 5.92822 11.0011 6.41703 10.7506C6.64153 13.3304 8.5575 15.4937 11.1379 15.9946C11.1575 15.9984 11.1775 16.0003 11.1974 16.0003C11.2173 16.0003 11.2373 15.9984 11.2569 15.9946C14.0053 15.4611 16 13.0418 16 10.242V6.08743C16 5.96951 15.9336 5.86163 15.8284 5.80847ZM4.80094 7.1116C4.30722 7.1116 3.82538 7.20999 3.37872 7.39963C3.62459 6.85711 4.17291 6.47661 4.80094 6.47661C5.42897 6.47661 5.97728 6.85708 6.22316 7.39963C5.7765 7.20999 5.29466 7.1116 4.80094 7.1116ZM15.375 10.242C15.375 12.7229 13.6217 14.8693 11.1974 15.369C8.77316 14.8693 7.01988 12.7229 7.01988 10.242V6.28197C9.65175 5.01993 12.7467 5.01987 15.375 6.28185V10.242H15.375Z" fill="#E9BE50" />
                                                        </svg>
                                                    </div>
                                                </div>
                                            </div>
                                            <ConditionalRoleBrief
                                                accessBrief={accessBrief}
                                                rpData={rpData}
                                                roleName={v.role_name}
                                                activityData={rpActivityData}
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        ))}
                        {/* <AllAudioConsumers
                            consumers={Object.values(consumers || {})}
                            privateRoomData={privateRoomUsers}
                            rpUsers={rpUsers}
                            currentDebriefedEmail={privateRoomUsers[0].userEmail}
                        /> */}
                    </div>
                );
            } else {
                return (
                    <div className="grid grid-cols-2 gap-1 h-full w-full">
                        {privateRoomUsers?.map((v, i) => (
                            <div
                                key={i}
                                className="relative"
                                style={{ height: boxSize.height, width: boxSize.width }}
                            >
                                <PeerView
                                    key={`private-grid-${v?.userEmail}`}
                                    caller="renderPrivateRoom"
                                    userDatax={privateRoomUsers}
                                    logicalMute={true}
                                    style={{ flex: 1, height: '100%', width: '100%' }}
                                    streamURL={processedStreams[v?.userEmail]}
                                    peerEmail={v?.userEmail}
                                />
                                <div className="absolute top-0 left-0 p-2">
                                    <Text
                                        as="span"
                                        size="2"
                                        className="text-white font-[Lato-Regular] bg-[rgba(0,0,0,0.5)] px-2 py-1 rounded"
                                    >
                                        {v?.userName}
                                    </Text>
                                    {showRoleName && !isBlankOrNull(v?.role_name) && (
                                        <Text
                                            as="span"
                                            size="2"
                                            className="text-white font-[Lato-Regular] bg-[rgba(0,0,0,0.5)] px-2 py-1 rounded block mt-1"
                                        >
                                            Role: {v?.role_name}
                                        </Text>
                                    )}
                                </div>
                            </div>
                        ))}
                    </div>
                );
            }
        }

        if (rpUsers.length <= 2) {
            return (
                <div className="flex flex-col h-full w-full">
                    {rpUsers.map((v, i) => (
                        <div key={i} className="flex-1 relative">
                            <PeerView
                                key={`rp-${v?.userEmail}`}
                                caller="renderPrivateRoom"
                                userDatax={rpUsers}
                                logicalMute={true}
                                style={{ flex: 1, height: '100vh', width: '100vh' }}
                                streamURL={processedStreams[v?.userEmail]}
                            />
                            <div className="absolute top-0 left-0 p-2">
                                <Text
                                    as="span"
                                    size="2"
                                    className="text-white font-[Lato-Regular] bg-[rgba(0,0,0,0.5)] px-2 py-1 rounded"
                                >
                                    {v?.userName}
                                </Text>
                                {showRoleName && !isBlankOrNull(v?.role_name) && (
                                    <Text
                                        as="span"
                                        size="2"
                                        className="text-white font-[Lato-Regular] bg-[rgba(0,0,0,0.5)] px-2 py-1 rounded block mt-1"
                                    >
                                        Role: {v?.role_name}
                                    </Text>
                                )}
                            </div>
                        </div>
                    ))}
                </div>
            );
        } else {
            return (
                <div className="grid grid-cols-2  h-full w-full">
                    {rpUsers?.map((v, i) => (
                        <div
                            key={i}
                            className="relative"
                            style={{ height: boxSize.height, width: boxSize.width }}
                        >
                            <PeerView
                                key={`rp-grid-${v?.userEmail}`}
                                caller="renderPrivateRoom"
                                userDatax={rpUsers}
                                logicalMute={true}
                                style={{ flex: 1, height: '100%', width: '100%' }}
                                streamURL={processedStreams[v?.userEmail]}
                            />
                            <div className="absolute top-0 left-0 p-2">
                                <Text
                                    as="span"
                                    size="2"
                                    className="text-white font-[Lato-Regular] bg-[rgba(0,0,0,0.5)] px-2 py-1 rounded"
                                >
                                    {v?.userName}
                                </Text>
                                {showRoleName && !isBlankOrNull(v?.role_name) && (
                                    <Text
                                        as="span"
                                        size="2"
                                        className="text-white font-[Lato-Regular] bg-[rgba(0,0,0,0.5)] px-2 py-1 rounded block mt-1"
                                    >
                                        Role: {v?.role_name}
                                    </Text>
                                )}
                            </div>
                        </div>
                    ))}
                </div>
            );
        }
    };


    const renderParticipants = () => {
        if (privateRoomData?.length > 0) {
            if (privateRoomData.length <= 2) {
                return (
                    <div className="flex flex-col h-full w-full">
                        {privateRoomData.map((v, i) => (
                            <div key={i} className="flex-1 relative">
                                <PeerView
                                    key={`participant-${v?.userEmail}`}
                                    caller="renderPrivateRoom"
                                    logicalMute={true}
                                    style={{ height: '80vh', width: '100vh' }}
                                    streamURL={processedStreams[v?.userEmail]}
                                />
                                <div className="absolute top-0 left-0 p-2">
                                    <Text
                                        as="span"
                                        size="2"
                                        className="text-white font-[Lato-Regular] bg-[rgba(0,0,0,0.5)] px-2 py-1 rounded"
                                    >
                                        {v?.userName}
                                    </Text>
                                    {showRoleName && v?.role_name && (
                                        <Text
                                            as="span"
                                            size="2"
                                            className="text-white font-[Lato-Regular] bg-[rgba(0,0,0,0.5)] px-2 py-1 rounded block mt-1"
                                        >
                                            Role: {v?.role_name}
                                        </Text>
                                    )}
                                </div>
                            </div>
                        ))}
                    </div>
                );
            } else {
                return (
                    <div className="grid grid-cols-2 gap-1 h-full w-full">
                        {privateRoomData?.map((v, i) => (
                            <div
                                key={i}
                                className="relative"
                                style={{ height: boxSize.height, width: boxSize.width }}
                            >
                                <PeerView
                                    key={`participant-grid-${v?.userEmail}`}
                                    caller="renderPrivateRoom"
                                    logicalMute={true}
                                    style={{ height: '80vh', width: '100vh', position: 'relative' }}
                                    streamURL={processedStreams[v?.userEmail]}
                                />
                                <div className="absolute top-0 left-0 p-2">
                                    <Text
                                        as="span"
                                        size="2"
                                        className="text-white font-[Lato-Regular] bg-[rgba(0,0,0,0.5)] px-2 py-1 rounded"
                                    >
                                        {v?.userName}
                                    </Text>
                                    {showRoleName && v?.role_name && (
                                        <Text
                                            as="span"
                                            size="2"
                                            className="text-white font-[Lato-Regular] bg-[rgba(0,0,0,0.5)] px-2 py-1 rounded block mt-1"
                                        >
                                            Role: {v?.role_name}
                                        </Text>
                                    )}
                                </div>
                            </div>
                        ))}
                    </div>
                );
            }
        }

        if (rpUsers.length <= 2) {
            return (
                <div className="relative h-full w-full tablet:flex-col mobile:flex-col tablet:flex tablet:justify-center mobile:flex mobile:justify-center">
                    {/* <div className="
    w-full
    z-50
    left-1/2
    -translate-x-1/2
    absolute
    top-5
    mobile:static
    tablet:static
    mobile:left-0
    tablet:left-0
    mobile:translate-x-0
    tablet:translate-x-0
    mobile:flex
    tablet:flex
    mobile:justify-center
    tablet:justify-center
    mobile:mt-10
    tablet:mt-10
  ">
                        <Trainer videoHeight={150} videoWidth={250} name={trainer?.fullname} trainerTableName="On Table 1" />
                    </div> */}
                    <div className="flex flex-col h-full w-full mobile:p-2">
                        {rpOngoing && (
                            <div className="flex justify-center items-center p-2">
                                <Text
                                    as="span"
                                    size="2"
                                    className="text-[#E9BE50] text-center font-[Lato-Regular]"
                                >
                                    Role Play Ongoing
                                </Text>
                                <div
                                    className="bg-green-500 border-[1.5px] border-[#E9BE50] h-[1.5vh] w-[1.5vh] rounded-full ml-[3%]"
                                />
                            </div>
                        )}
                        <div className="flex mobile:flex-col flex-row h-full gap-1 tablet:grid-cols-1 mobile:grid-cols-1 grid grid-cols-2 mobile:gap-4">
                            {rpUsers.map((v, i) => (
                                <div key={i} className="mobile:flex-1 flex flex-col h-full">
                                    <div className="relative w-full h-full rounded-2xl" style={{ boxShadow: '0 2px 16px 0 rgba(33, 30, 55, 0.30)' }}
                                    >
                                        <PeerView
                                            key={`rp-participant-${v?.userEmail}`}
                                            caller="renderPrivateRoom"
                                            logicalMute={true}
                                            style={{ height: 'mobile:h-72', width: '100%', position: 'relative', ObjectFit: 'cover' }}
                                            streamURL={processedStreams[v?.userEmail]}
                                            height={580}
                                        />
                                        <ConditionalRoleBrief
                                            accessBrief={accessBrief}
                                            rpData={rpData}
                                            roleName={v.role_name}
                                            activityData={rpActivityData}
                                        />
                                        <div className="absolute mobile:w-3/2 w-1/2  right-2 bottom-4 bg-[rgba(36,39,44,0.6)] rounded-md p-2">
                                            <div className="flex items-center justify-between">
                                                {/* LEFT: Name + Role */}
                                                <div className="flex flex-col items-start justify-center">
                                                    <Text
                                                        as="span"
                                                        size="2"
                                                        className="mobile:text-xs text-sm text-white font-[Lato-Regular] text-left"
                                                    >
                                                        {v?.userName}
                                                    </Text>
                                                    {(showRoleName || v?.role_name) && (
                                                        <Text
                                                            as="span"
                                                            size="2"
                                                            className="text-white font-[Lato-Regular] text-center"
                                                            style={{ fontWeight: 400, fontSize: '14px', color: '#E9BE50' }}
                                                        >
                                                            Role: {v?.role_name}
                                                        </Text>
                                                    )}
                                                </div>

                                                {/* RIGHT: SVG inside black circle */}
                                                <div className="flex items-center justify-center rounded-full bg-black p-2 ml-3">
                                                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                                                        <path d="M15.8284 5.80847C14.4012 5.0875 12.8004 4.70644 11.199 4.70644C11.1986 4.70644 11.1981 4.70644 11.1977 4.70644C10.6648 4.7065 10.1318 4.74903 9.60509 4.83198V1.37988C9.60509 1.26197 9.53872 1.15408 9.4335 1.10092C8.43169 0.594912 7.36006 0.258416 6.24831 0.100809C6.07766 0.0764943 5.91928 0.195473 5.89503 0.366362C5.87084 0.537251 5.98969 0.695451 6.16059 0.719672C7.14141 0.858746 8.08894 1.14602 8.98009 1.57431V4.95008C8.14388 5.13491 7.33056 5.42306 6.56666 5.8084C6.46134 5.86153 6.39491 5.96948 6.39491 6.08746V6.54287C6.37419 6.52077 6.35322 6.49887 6.3315 6.47752C5.92059 6.07389 5.37703 5.85162 4.80094 5.85162C4.22484 5.85162 3.68131 6.07389 3.27038 6.47752C2.86009 6.88049 2.62791 7.41888 2.61659 7.99346C2.61431 8.11034 2.67741 8.21873 2.78016 8.27442C2.883 8.33014 3.00822 8.32377 3.10484 8.25801C3.60591 7.91695 4.19241 7.73669 4.80091 7.73669C5.36859 7.73669 5.917 7.8937 6.39488 8.19163V10.0498C5.90137 10.3397 5.36681 10.5453 4.80253 10.6615C2.37825 10.1618 0.625 8.01537 0.625 5.53454V1.5744C1.51606 1.14671 2.46309 0.85959 3.443 0.720266C3.61388 0.695983 3.73272 0.537751 3.70841 0.366862C3.68412 0.195973 3.52566 0.0771818 3.35503 0.101434C2.24441 0.259353 1.17341 0.595599 0.171781 1.10083C0.0664375 1.15399 0 1.2619 0 1.37988V5.53454C0 8.33433 1.99472 10.7536 4.743 11.287C4.76266 11.2908 4.78263 11.2927 4.80253 11.2927C4.82244 11.2927 4.84241 11.2908 4.86206 11.287C5.40722 11.1812 5.92822 11.0011 6.41703 10.7506C6.64153 13.3304 8.5575 15.4937 11.1379 15.9946C11.1575 15.9984 11.1775 16.0003 11.1974 16.0003C11.2173 16.0003 11.2373 15.9984 11.2569 15.9946C14.0053 15.4611 16 13.0418 16 10.242V6.08743C16 5.96951 15.9336 5.86163 15.8284 5.80847ZM4.80094 7.1116C4.30722 7.1116 3.82538 7.20999 3.37872 7.39963C3.62459 6.85711 4.17291 6.47661 4.80094 6.47661C5.42897 6.47661 5.97728 6.85708 6.22316 7.39963C5.7765 7.20999 5.29466 7.1116 4.80094 7.1116ZM15.375 10.242C15.375 12.7229 13.6217 14.8693 11.1974 15.369C8.77316 14.8693 7.01988 12.7229 7.01988 10.242V6.28197C9.65175 5.01993 12.7467 5.01987 15.375 6.28185V10.242H15.375Z" fill="#E9BE50" />
                                                    </svg>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                            ))}
                        </div>
                    </div>
                </div>
            );
        } else {
            return (
                <div className="grid grid-cols-2 gap-1 h-full w-full">
                    {rpUsers?.map((v, i) => (
                        <div
                            key={i}
                            className="relative"
                            style={{ height: boxSize.height, width: boxSize.width }}
                        >
                            <PeerView
                                key={`rp-participant-grid-${v?.userEmail}`}
                                caller="renderPrivateRoom"
                                logicalMute={true}
                                style={{ flex: 1, height: '100vh', width: '100vh' }}
                                streamURL={processedStreams[v?.userEmail]}
                            />
                            <div className="absolute top-0 left-0 p-2">
                                <Text
                                    as="span"
                                    size="2"
                                    className="text-white font-[Lato-Regular] bg-[rgba(0,0,0,0.5)] px-2 py-1 rounded"
                                >
                                    {v?.userName}
                                </Text>
                                {showRoleName || v?.role_name && (
                                    <Text
                                        as="span"
                                        size="2"
                                        className="text-white font-[Lato-Regular] bg-[rgba(0,0,0,0.5)] px-2 py-1 rounded block mt-1"
                                    >
                                        Role: {v?.role_name}
                                    </Text>
                                )}
                            </div>
                        </div>
                    ))}
                </div>
            );
        }
    };


    const renderMainPart = () => {
        if (openClassInteraction) {
            return renderOpenClassInteraction()
        }
        else if (roleplayAnalysisEnded) {
            return endRenderProgress()
            // return renderTableView()
        }
        else if (isPreRecorded) {
            return renderVideoPlayer()
        }
        else if (privateRoomData?.length > 0 && openPrivatRoom) {
            return renderPrivateRoom()
        }
        else if (roleplayLaunched) {
            return renderParticipants()
        }
        else if (isBriefing) {
            return renderParticipants()
        }
        else if (isRenderPrgoress) {
            return renderProgress()
        }
    }
    const startTimer = (minutes: any) => {
        setTimeLeft(Number(minutes) * 60);
    };

    const renderProgress = () => (
        <>
            <div className="h-full p-5 flex items-center justify-center">
                <div className="w-full flex justify-center mobile:mb-4 ">
                    <div className="bg-[#24272C] relative w-[28rem] largescreen:h-64 max-w-[536px] mobile:max-w-[90%]  mobile:h-48 tablet:h-48 laptop:h-56 desktop:h-56 bg-gray-800 rounded-2xl flex flex-col items-center justify-center shadow-lg" style={{
                        background: '#24272C',
                        boxShadow: '-6px -6px 12px rgba(255, 255, 255, 0.25), 6px 6px 12px rgba(0, 0, 0, 0.25)',
                    }}>
                        {/* SVG at top-left */}
                        <svg
                            width="72"
                            height="78"
                            viewBox="0 0 72 78"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                            className="absolute top-2 left-2 mobile:w-[30px] mobile:h-[30px] tablet:w-[40px] tablet:h-[40px] laptop:w-[50px] laptop:h-[50px] desktop:w-[57px] desktop:h-[57px]"
                        >
                            <g clip-path="url(#clip0_6083_3511)">
                                <path
                                    d="M22.0274 15.0335C24.609 15.0335 27.0358 14.0457 28.861 12.2522C29.5303 11.5945 29.5303 10.5281 28.861 9.87039C28.1915 9.2127 27.1064 9.2127 26.4367 9.87039C25.259 11.0276 23.693 11.6649 22.0272 11.6649C20.3616 11.6649 18.7954 11.0276 17.6177 9.87022C16.9481 9.21253 15.8631 9.21253 15.1934 9.87022C14.5241 10.5279 14.5241 11.5943 15.1934 12.252C17.0191 14.0459 19.4459 15.0335 22.0274 15.0335Z"
                                    fill="white"
                                />
                                <path
                                    d="M-0.410292 11.6647C-2.07606 11.6647 -3.64206 11.0274 -4.81982 9.87022C-5.48918 9.21253 -6.5742 9.21253 -7.24408 9.87022C-7.91343 10.5279 -7.91343 11.5943 -7.24408 12.252C-5.4189 14.0456 -2.9919 15.0333 -0.410464 15.0333C2.17097 15.0333 4.5978 14.0457 6.42315 12.2522C7.09251 11.5945 7.09251 10.5281 6.42315 9.87039C5.75379 9.2127 4.66877 9.2127 3.99889 9.87039C2.82148 11.0274 1.2553 11.6647 -0.410292 11.6647Z"
                                    fill="white"
                                />
                                <path
                                    d="M70.8208 23.3012C62.9922 19.4159 54.212 17.3623 45.4279 17.3623C45.4259 17.3623 45.4231 17.3623 45.4209 17.3623C42.4975 17.3626 39.5741 17.5919 36.6852 18.0388V-0.564641C36.6852 -1.20009 36.3211 -1.78149 35.7439 -2.06797C30.2489 -4.79488 24.3709 -6.60827 18.2728 -7.45762C17.3367 -7.58865 16.468 -6.94747 16.335 -6.02654C16.2023 -5.10562 16.8542 -4.25307 17.7916 -4.12254C23.1715 -3.37307 28.3689 -1.82494 33.257 0.483108V18.6753C28.6702 19.6713 24.2091 21.2242 20.0189 23.3008C19.4413 23.5871 19.0769 24.1689 19.0769 24.8047V27.2589C18.9632 27.1398 18.8482 27.0218 18.7291 26.9067C16.4752 24.7316 13.4937 23.5338 10.3338 23.5338C7.17381 23.5338 4.19247 24.7316 1.93842 26.9067C-0.312021 29.0784 -1.5856 31.9797 -1.64765 35.0762C-1.66016 35.7061 -1.31409 36.2901 -0.750489 36.5903C-0.186378 36.8906 0.500463 36.8562 1.03046 36.5019C3.77886 34.6639 6.99588 33.6924 10.3336 33.6924C13.4474 33.6924 16.4555 34.5386 19.0767 36.1441V46.158C16.3698 47.7202 13.4377 48.8283 10.3425 49.4545C-2.955 46.7614 -12.5718 35.1942 -12.5718 21.825V0.483613C-7.6842 -1.82123 -2.48962 -3.36852 2.88529 -4.11934C3.82257 -4.2502 4.47444 -5.10292 4.34108 -6.02385C4.2079 -6.94478 3.33867 -7.58495 2.40277 -7.45425C-3.68915 -6.60322 -9.56372 -4.79117 -15.0578 -2.06848C-15.6356 -1.78199 -16 -1.20043 -16 -0.564641V21.825C-16 36.9131 -5.05871 49.9506 10.016 52.8253C10.1238 52.8458 10.2333 52.8561 10.3425 52.8561C10.4517 52.8561 10.5612 52.8458 10.669 52.8253C13.6593 52.255 16.517 51.2847 19.1982 49.9345C20.4296 63.8371 30.939 75.4953 45.0927 78.1944C45.2005 78.2149 45.31 78.2252 45.4192 78.2252C45.5284 78.2252 45.6379 78.2149 45.7457 78.1944C60.8207 75.3196 71.762 62.2821 71.762 47.1939V24.8045C71.762 24.169 71.398 23.5876 70.8208 23.3012ZM10.3338 30.3238C7.62564 30.3238 4.98267 30.854 2.5327 31.876C3.88136 28.9524 6.88892 26.9018 10.3338 26.9018C13.7786 26.9018 16.7862 28.9522 18.1348 31.876C15.6848 30.854 13.0419 30.3238 10.3338 30.3238ZM68.3338 47.1939C68.3338 60.5632 58.717 72.1305 45.4194 74.8233C32.1219 72.1304 22.5049 60.5632 22.5049 47.1939V25.8529C36.9411 19.0517 53.9174 19.0514 68.3337 25.8522V47.1939H68.3338Z"
                                    fill="white"
                                />
                                <path
                                    d="M39.0733 39.8969C39.408 40.2258 39.8467 40.3902 40.2853 40.3902C40.724 40.3902 41.1626 40.2258 41.4974 39.8969C42.1667 39.2392 42.1667 38.1727 41.4974 37.5149C37.7296 33.8128 31.5983 33.8127 27.8301 37.5149C27.1608 38.1726 27.1608 39.239 27.8301 39.8967C28.4997 40.5546 29.5847 40.5546 30.2544 39.8967C32.6857 37.5078 36.6422 37.508 39.0733 39.8969Z"
                                    fill="white"
                                />
                                <path
                                    d="M51.4836 40.39C51.9224 40.39 52.3609 40.2256 52.6956 39.8966C55.1267 37.5078 59.0832 37.5074 61.5145 39.8966C62.184 40.5543 63.2694 40.5543 63.9388 39.8966C64.6081 39.239 64.6081 38.1725 63.9388 37.5148C60.1705 33.8126 54.0395 33.8129 50.2715 37.5148C49.6022 38.1725 49.6022 39.239 50.2715 39.8968C50.6061 40.2256 51.0448 40.39 51.4836 40.39Z"
                                    fill="white"
                                />
                                <path
                                    d="M56.4953 49.9768C55.9314 49.6767 55.2444 49.7109 54.7144 50.0652C51.966 51.9032 48.749 52.8747 45.4113 52.8747C42.0736 52.8747 38.8565 51.9032 36.1081 50.0654C35.5781 49.711 34.8913 49.6767 34.3272 49.977C33.7636 50.2771 33.4173 50.8612 33.43 51.4911C33.4921 54.5877 34.7657 57.4889 37.0161 59.6605C39.27 61.8357 42.2515 63.0335 45.4114 63.0335C48.5714 63.0335 51.5527 61.8357 53.8068 59.6605C56.0572 57.4889 57.3308 54.5875 57.3928 51.4911C57.405 50.861 57.0589 50.2768 56.4953 49.9768ZM45.4113 59.6649C41.9664 59.6649 38.9589 57.6145 37.6102 54.6908C40.0602 55.7127 42.7031 56.2429 45.4113 56.2429C48.1194 56.2429 50.7623 55.7127 53.2123 54.6908C51.8635 57.6145 48.8559 59.6649 45.4113 59.6649Z"
                                    fill="white"
                                />
                            </g>
                            <defs>
                                <clipPath id="clip0_6083_3511">
                                    <path d="M0 16C0 7.16344 7.16344 0 16 0H72V78H0V16Z" fill="white" />
                                </clipPath>
                            </defs>
                        </svg>

                        {/* Centered content */}
                        <div className="max-w-[300px] flex flex-col items-center justify-center space-y-2 mobile:space-y-1 tablet:space-y-2 laptop:space-y-3 desktop:space-y-4">
                            <Text
                                as="span"
                                size="4"
                                weight="bold"
                                className="text-white text-base font-normal leading-none font-[Lato] largescreen:text-[14px] text-center mobile:text-sm tablet:text-sm laptop:text-md desktop:text-xl"
                            >
                                Role Play setup in progress ...
                            </Text>
                            <Text
                                as="span"
                                size="3"
                                className="text-[#E9BE50] text-2xl font-medium italic leading-none font-[Lato] px-4 text-center mobile:text-xs tablet:text-sm laptop:text-base desktop:text-lg"
                            >
                                Role Players being selected
                            </Text>
                        </div>
                    </div>
                </div>
                {/* <div className="flex flex-col items-center">
                    <img
                        src={roleplay}
                        alt="Role Play"
                        className="w-[40vw] h-[40vw] max-w-[150px] max-h-[150px] object-contain"
                    />
                    <Text
                        as="span"
                        size="4"
                        weight="bold"
                        className="text-white font-[Lato-Bold] mt-4 text-center"
                    >
                        Role Play setup in progress ...
                    </Text>
                    <Text
                        as="span"
                        size="3"
                        className="text-white font-[Lato-Regular] mt-2 text-center"
                    >
                        Role Players being selected
                    </Text>
                </div> */}
            </div>
        </>
    );


    const endRenderProgress = () => (
        <>
            <div className="h-full p-5 flex justify-center items-center">
                <div className="bg-[#24272C] relative w-[30rem] largescreen:h-64 max-w-[536px] mobile:max-w-[90%] mobile:w-80  mobile:h-48 tablet:h-64 laptop:h-72 desktop:h-72 bg-gray-800 rounded-2xl flex flex-col items-center justify-center shadow-lg">
                    {/* SVG at top-left */}
                    <svg
                        width="72"
                        height="78"
                        viewBox="0 0 72 78"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                        className="absolute top-2 left-2 mobile:w-[40px] mobile:h-[40px] tablet:w-[40px] tablet:h-[40px] laptop:w-[50px] laptop:h-[50px] desktop:w-[57px] desktop:h-[57px]"
                    >
                        <g clip-path="url(#clip0_6083_3511)">
                            <path
                                d="M22.0274 15.0335C24.609 15.0335 27.0358 14.0457 28.861 12.2522C29.5303 11.5945 29.5303 10.5281 28.861 9.87039C28.1915 9.2127 27.1064 9.2127 26.4367 9.87039C25.259 11.0276 23.693 11.6649 22.0272 11.6649C20.3616 11.6649 18.7954 11.0276 17.6177 9.87022C16.9481 9.21253 15.8631 9.21253 15.1934 9.87022C14.5241 10.5279 14.5241 11.5943 15.1934 12.252C17.0191 14.0459 19.4459 15.0335 22.0274 15.0335Z"
                                fill="white"
                            />
                            <path
                                d="M-0.410292 11.6647C-2.07606 11.6647 -3.64206 11.0274 -4.81982 9.87022C-5.48918 9.21253 -6.5742 9.21253 -7.24408 9.87022C-7.91343 10.5279 -7.91343 11.5943 -7.24408 12.252C-5.4189 14.0456 -2.9919 15.0333 -0.410464 15.0333C2.17097 15.0333 4.5978 14.0457 6.42315 12.2522C7.09251 11.5945 7.09251 10.5281 6.42315 9.87039C5.75379 9.2127 4.66877 9.2127 3.99889 9.87039C2.82148 11.0274 1.2553 11.6647 -0.410292 11.6647Z"
                                fill="white"
                            />
                            <path
                                d="M70.8208 23.3012C62.9922 19.4159 54.212 17.3623 45.4279 17.3623C45.4259 17.3623 45.4231 17.3623 45.4209 17.3623C42.4975 17.3626 39.5741 17.5919 36.6852 18.0388V-0.564641C36.6852 -1.20009 36.3211 -1.78149 35.7439 -2.06797C30.2489 -4.79488 24.3709 -6.60827 18.2728 -7.45762C17.3367 -7.58865 16.468 -6.94747 16.335 -6.02654C16.2023 -5.10562 16.8542 -4.25307 17.7916 -4.12254C23.1715 -3.37307 28.3689 -1.82494 33.257 0.483108V18.6753C28.6702 19.6713 24.2091 21.2242 20.0189 23.3008C19.4413 23.5871 19.0769 24.1689 19.0769 24.8047V27.2589C18.9632 27.1398 18.8482 27.0218 18.7291 26.9067C16.4752 24.7316 13.4937 23.5338 10.3338 23.5338C7.17381 23.5338 4.19247 24.7316 1.93842 26.9067C-0.312021 29.0784 -1.5856 31.9797 -1.64765 35.0762C-1.66016 35.7061 -1.31409 36.2901 -0.750489 36.5903C-0.186378 36.8906 0.500463 36.8562 1.03046 36.5019C3.77886 34.6639 6.99588 33.6924 10.3336 33.6924C13.4474 33.6924 16.4555 34.5386 19.0767 36.1441V46.158C16.3698 47.7202 13.4377 48.8283 10.3425 49.4545C-2.955 46.7614 -12.5718 35.1942 -12.5718 21.825V0.483613C-7.6842 -1.82123 -2.48962 -3.36852 2.88529 -4.11934C3.82257 -4.2502 4.47444 -5.10292 4.34108 -6.02385C4.2079 -6.94478 3.33867 -7.58495 2.40277 -7.45425C-3.68915 -6.60322 -9.56372 -4.79117 -15.0578 -2.06848C-15.6356 -1.78199 -16 -1.20043 -16 -0.564641V21.825C-16 36.9131 -5.05871 49.9506 10.016 52.8253C10.1238 52.8458 10.2333 52.8561 10.3425 52.8561C10.4517 52.8561 10.5612 52.8458 10.669 52.8253C13.6593 52.255 16.517 51.2847 19.1982 49.9345C20.4296 63.8371 30.939 75.4953 45.0927 78.1944C45.2005 78.2149 45.31 78.2252 45.4192 78.2252C45.5284 78.2252 45.6379 78.2149 45.7457 78.1944C60.8207 75.3196 71.762 62.2821 71.762 47.1939V24.8045C71.762 24.169 71.398 23.5876 70.8208 23.3012ZM10.3338 30.3238C7.62564 30.3238 4.98267 30.854 2.5327 31.876C3.88136 28.9524 6.88892 26.9018 10.3338 26.9018C13.7786 26.9018 16.7862 28.9522 18.1348 31.876C15.6848 30.854 13.0419 30.3238 10.3338 30.3238ZM68.3338 47.1939C68.3338 60.5632 58.717 72.1305 45.4194 74.8233C32.1219 72.1304 22.5049 60.5632 22.5049 47.1939V25.8529C36.9411 19.0517 53.9174 19.0514 68.3337 25.8522V47.1939H68.3338Z"
                                fill="white"
                            />
                            <path
                                d="M39.0733 39.8969C39.408 40.2258 39.8467 40.3902 40.2853 40.3902C40.724 40.3902 41.1626 40.2258 41.4974 39.8969C42.1667 39.2392 42.1667 38.1727 41.4974 37.5149C37.7296 33.8128 31.5983 33.8127 27.8301 37.5149C27.1608 38.1726 27.1608 39.239 27.8301 39.8967C28.4997 40.5546 29.5847 40.5546 30.2544 39.8967C32.6857 37.5078 36.6422 37.508 39.0733 39.8969Z"
                                fill="white"
                            />
                            <path
                                d="M51.4836 40.39C51.9224 40.39 52.3609 40.2256 52.6956 39.8966C55.1267 37.5078 59.0832 37.5074 61.5145 39.8966C62.184 40.5543 63.2694 40.5543 63.9388 39.8966C64.6081 39.239 64.6081 38.1725 63.9388 37.5148C60.1705 33.8126 54.0395 33.8129 50.2715 37.5148C49.6022 38.1725 49.6022 39.239 50.2715 39.8968C50.6061 40.2256 51.0448 40.39 51.4836 40.39Z"
                                fill="white"
                            />
                            <path
                                d="M56.4953 49.9768C55.9314 49.6767 55.2444 49.7109 54.7144 50.0652C51.966 51.9032 48.749 52.8747 45.4113 52.8747C42.0736 52.8747 38.8565 51.9032 36.1081 50.0654C35.5781 49.711 34.8913 49.6767 34.3272 49.977C33.7636 50.2771 33.4173 50.8612 33.43 51.4911C33.4921 54.5877 34.7657 57.4889 37.0161 59.6605C39.27 61.8357 42.2515 63.0335 45.4114 63.0335C48.5714 63.0335 51.5527 61.8357 53.8068 59.6605C56.0572 57.4889 57.3308 54.5875 57.3928 51.4911C57.405 50.861 57.0589 50.2768 56.4953 49.9768ZM45.4113 59.6649C41.9664 59.6649 38.9589 57.6145 37.6102 54.6908C40.0602 55.7127 42.7031 56.2429 45.4113 56.2429C48.1194 56.2429 50.7623 55.7127 53.2123 54.6908C51.8635 57.6145 48.8559 59.6649 45.4113 59.6649Z"
                                fill="white"
                            />
                        </g>
                        <defs>
                            <clipPath id="clip0_6083_3511">
                                <path d="M0 16C0 7.16344 7.16344 0 16 0H72V78H0V16Z" fill="white" />
                            </clipPath>
                        </defs>
                    </svg>

                    {/* Centered content */}
                    <div className="mobile:p-3 mobile:mt-5 max-w-[300px] flex flex-col items-center justify-center space-y-2 mobile:space-y-1 tablet:space-y-2 laptop:space-y-3 desktop:space-y-4">
                        <Text
                            as="span"
                            size="4"
                            weight="bold"
                            className="text-white text-[14px] font-[Lato-Bold] largescreen:text-[16px] text-center mobile:text-sm tablet:text-sm laptop:text-base desktop:text-xl"
                        >
                            Role Playing has ended
                        </Text>
                        <Text
                            as="span"
                            size="3"
                            className="text-white text-[14px] font-[Lato-Italic] px-4 text-center mobile:text-xs tablet:text-sm laptop:text-base desktop:text-lg"
                        >
                            Standby for further instructions from trainer
                        </Text>
                    </div>
                </div>
                {/* <div className="flex flex-col items-center border border-white-900 rounded-lg p-4 shadow-md max-w-md w-full">
                    <img
                        src={roleplay}
                        alt="Roleplay"
                        className="w-[40vw] max-w-[200px] h-[40vw] max-h-[200px] object-contain"
                    />
                    <Text
                        as="p"
                        size="5"
                        weight="bold"
                        className="text-white text-center mt-4 font-[Lato-Bold]"
                    >
                        Role Playing has ended
                    </Text>
                    <Text
                        as="p"
                        size="3"
                        className="text-white text-center mt-2 font-[Lato-Regular]"
                    >
                        Standby for further instructions from trainer
                    </Text>
                </div> */}
            </div>
            {/* <MyView /> */}
        </>
    );
    const rolePlayAccept = () => {
        setShowRoleplayModal(false);
        let user_data = {
            userEmail: profileData?.email,
            userName: profileData?.name,
        };
        removeTimeouts();
        if (!userInfoHandler.current) {
            userInfoHandler.current = validateAndCreateSocketIfExist(session_id, handleOnMessage, socketList);
        }
        userInfoHandler.current.sendMessage(
            JSON.stringify({
                type: rolePlaySubType.VOLUNTEERS_REQUEST_ACCEPTED,
                user_data,
                room_id: session_id,
            })
        );
        setIsRolePlayAccepted(true);
        setTimeout(() => {
            setRpMode(`YOU_SELECTED`);
        }, 1000);
    };
    const removeTimeouts = () => {
        try {
            if (!timer) {
                clearInterval(timer);
            }
        } catch (err) {
            console.log('Error while removing')
        }
    }

    const startManuallyPresentation = () => {
        userInfoHandler.current = validateAndCreateSocketIfExist(session_id, handleOnMessage, socketList);


        let obj1 = {};
        const isEmailMatched = manuallySelected?.seats.filter((item) => {
            if (item.participant_email === profileData?.email) {
                return item;
            }
        });
        console.log(isEmailMatched, "isEmailMatched")
        if (isEmailMatched[0].participant_email) {
            obj1 = {
                seat_number: isEmailMatched?.seat_number,
                participant_id: isEmailMatched?.participant_id,
                participant_name: isEmailMatched.participant_name,
                participant_email: isEmailMatched?.participant_email,
                profilePhoto: 'null'
            };
        }
        console.log(obj1, "selectedParticipant")

        userInfoHandler.current.sendMessage(
            JSON.stringify({
                type: 'role_play',
                sub_type: 'launch_presentation_screen',
                room_id: session_id,
                activityData: {
                    TableName: manuallySelected?.table_name,
                    action: 'start_own_presentation',
                    role: 'role_play',
                    trainee: isEmailMatched[0]
                }
            })
        );
        setHideOurDraggableView(true);
        setIsIamRepresentingGroup(true);
        // setModalMode(csModalType.NOMINATEPRESENTER);
        //set the scrren where trainee will be presenting for his group

    };

    const declineSystemSelect = () => {
        userInfoHandler.current = validateAndCreateSocketIfExist(session_id, handleOnMessage, socketList);
        let payload = {
            type: socketMessageType.ROLE_PLAY,
            sub_type: socketMessageSubType.SYSTEM_REQUEST_DECLINED,
            room_id: session_id,
            timestamp: new Date(),
            email: profileData?.email
        }
        userInfoHandler.current.sendMessage(JSON.stringify(payload));
    }

    const nominateGroupleader = (nominee: any) => {
        if (nominee) {
            if (!userInfoHandler.current) {
                userInfoHandler.current = validateAndCreateSocketIfExist(session_id, handleOnMessage, socketList);
            }
            let payload = {
                sub_type: "select_group_leader_each_GM",
                type: "role_play",
                room_id: session_id,
                activityData: [
                    {
                        selectedParticipant: nominee,
                        whoSelected: profileData?.email
                    }
                ],
                timestamp: new Date()
            }
            userInfoHandler.current.sendMessage(JSON.stringify(payload));
            setRpMode(undefined);
        } else {

        }
    };

    const EndPresentation = () => {
        setHideOurDraggableView(false);
        userInfoHandler.current = validateAndCreateSocketIfExist(session_id, handleOnMessage, socketList);
        // setModalMode('WHEN_GROUP_IS_PRESENTING');
        var obj1 = {
            seat_number: rpSelectedTraineeForPresentation?.seat_number,
            participant_id: rpSelectedTraineeForPresentation?.participant_id,
            participant_name: rpSelectedTraineeForPresentation?.participant_name,
            participant_email: rpSelectedTraineeForPresentation?.participant_email,
            profilePhoto: 'null'
        }

        userInfoHandler.current.sendMessage(
            JSON.stringify({
                type: "role_play",
                sub_type: "launch_presentation_screen",
                room_id: session_id,
                activityData: {
                    TableName: "Group 1",
                    action: "end_own_presentation",
                    role: "role_play",
                    trainee: obj1
                }
            })
        );

        // setRpMode(undefined)
        setRpMode("SELECTION_OF_GROUP_REPRESENTATION_BY_PARTICIPANTS");

    }

    const allNominateGroupleader = (nominee: any) => {
        if (nominee) {
            if (!userInfoHandler.current) {
                userInfoHandler.current = validateAndCreateSocketIfExist(session_id, handleOnMessage, socketList);
            }
            let payload = {
                sub_type: "each_leader_select_GM",
                type: "role_play",
                room_id: session_id,
                activityData: {
                    selectedLeader: nominee,
                    currentGroupName: tblData?.table_name,
                    selected_by: profileData?.email
                },
                timestamp: new Date()
            }
            userInfoHandler.current.sendMessage(JSON.stringify(payload));
            setRpMode(undefined);
        } else {

        }
    };

    const prensentationTimeExtendModal = () => {
        return (
            <Dialog.Root open={presenterTimer}>
                <Dialog.Content className="fixed inset-0 flex justify-center items-end bg-black/60 w-full h-[20vh] p-4">
                    <div className="px-5 py-4 w-[70vw] max-w-md flex justify-center items-center rounded-lg bg-white shadow-lg">
                        <Text
                            as="span"
                            size="3"
                            weight="bold"
                            className="text-gray-900 text-center"
                        >
                            Trainer has extended the Presentation duration by {preTimer?.extend_time} Minutes
                        </Text>
                    </div>
                </Dialog.Content>
            </Dialog.Root>
        );
    };

    const handleOnMessage = async (_data: any) => {
        const data = JSON.parse(_data);
        console.log('ROLE_PLAY123', data);

        if (data.type === 'role_play' && data?.sub_type === 'selected_group_order' && data?.step === 'end_presentation') {
            setRoleplayAnalysisEnded(true)
        }

        setShowRoleName(data?.activity_data?.show_role_name ? true : false);
        if (data.type == socketMessageType.LIVE_SESSION && data.sub_type == socketMessageSubType.TIME_EXTEND && data.step == socketSteps.PRESENTATION) {
            setPresenterTimer(true)
            setPreTimer(data)
            setTimeout(() => {
                setPresenterTimer(false)
            }, 3000);

        }

        if (data.type === 'role_play' && data.sub_type === null) {
            const parseActivityData = parseToJson(data?.activityData);
            setRpUsers([]);

            let rolesArray = [];
            if (parseActivityData?.types_of_role_play === RolePlayLaunchedType.OpenRolePlay) {
                // For Open Role Play, populate missing attachment_url from role_brief_url
                rolesArray = Array.isArray(parseActivityData?.roles)
                    ? parseActivityData.roles.map((role: any) => ({
                        ...role,
                        attachment_url: role.attachment_url || parseActivityData.role_brief_url
                    }))
                    : [{
                        ...parseActivityData.roles,
                        attachment_url: parseActivityData.roles?.attachment_url || parseActivityData.role_brief_url
                    }];

                // Also update the activityData roles
                parseActivityData.roles = rolesArray;
            } else {
                rolesArray = Array.isArray(parseActivityData?.roles)
                    ? parseActivityData.roles
                    : [parseActivityData.roles];
            }
            setRpData(rolesArray);
            setRpActivityData(parseActivityData);
            setAccessBriefCondition(parseActivityData?.share_brief);
        }

        if (data?.type == 'role_play') {
            console.log(data, "data!!!!!!!!!!!!!!!!!!!!!!!")
            if (data?.sub_type === "launch_presentation_screen") {
                setRpMode('SELECTION_OF_GROUP_REPRESENTATION_BY_PARTICIPANTS')
            }
            if (data?.sub_type === "roleplay_launched") {
                setRpOnging(true)
            }
            if (data?.sub_type === "end_role_play") {
                setRpOnging(false)
                // setShouldShowisRoleplayLaunched(false);
            }
            if (data?.sub_type === "ask_group_to_present_presenation") {
                if (data?.activity_data) {
                    setmanuallySelected(data.activity_data);
                    setRpMode("SELECTION_OF_GROUP_REPRESENTATION_BY_PARTICIPANTS1");
                    if (data?.activity_data.seats) {
                        let isPresent = data.activity_data.seats.some(seat => seat.participant_email === profileData?.email);
                        if (isPresent) {
                            showPresentModal()
                        }
                    }
                }
            }
            if (data.sub_type === "selected_group_order") {
                if (data.groupGoingToPresent) {
                    setmanuallySelected(data?.groupGoingToPresent);
                    setRoleplayAnalysisEnded(false)
                    setIsRenderPrgoress(false)
                }
            }
        }
        if (data?.type === 'role_play') {
            if (data?.sub_type == 'selected_group_order') {
                if (data?.step === "end_presentation") {
                    setRpMode(false);
                    return
                }
            }
        }
        if (data?.type === 'role_play' && data?.sub_type === 'system_request_accepted') {
            //setting users screen to blank from the same group:----
            console.log('Hiii::::::::::::::::::::::ding 1', data?.user_data?.seatingPlan)

            console.log('Hiii::::::::::::::::::::::ding 1', typeof (data?.user_data?.seatingPlan))

            var newDatax = data?.user_data?.seatingPlan;

            if (typeof newDatax === 'object' && Array.isArray(newDatax)) {
                console.log('newDatax is an array');

                var newData = newDatax;
            } else if (typeof newDatax === 'object') {
                console.log('newDatax is an object');
                var newData = [newDatax];
            } else {
                console.log('newData is neither an object nor an array');
            }


            const checkEmails = (email1, email2, newData) => {
                console.log('checkIfOurGroupAcceptedTheEmail:::::::::::::::1', newData)
                for (let i = 0; i < newData.length; i++) {
                    console.log('checkIfOurGroupAcceptedTheEmail:::::::::::::::2', i)
                    const group = newData[i];
                    console.log('checkIfOurGroupAcceptedTheEmail:::::::::::::::3', group);

                    const seats = group?.seats;
                    console.log('checkIfOurGroupAcceptedTheEmail:::::::::::::::4', seats)
                    let email1Found = false;
                    let email2Found = false;

                    for (let j = 0; j < seats.length; j++) {

                        console.log('checkIfOurGroupAcceptedTheEmail:::::::::::::::5')
                        const participant = seats[j];
                        //
                        if (participant.participant_email === email1) {
                            console.log('checkIfOurGroupAcceptedTheEmail:::::::::::::::6', email1)
                            email1Found = true;
                        }
                        else if (participant.participant_email === email2) {
                            console.log('checkIfOurGroupAcceptedTheEmail:::::::::::::::7', email2)
                            // return true;
                            email2Found = true;

                        }
                    }

                    if (email1Found === true) {
                        if (email2Found == true) {
                            return true;
                        }
                    }

                    if (email2Found === true) {
                        if (email1Found == true) {
                            return true;
                        }
                    }

                }
                return false;
            }


            console.log('checkIfOurGroupAcceptedTheEmail:::::::::::0', profileData?.email, data?.user_data?.userEmail)
            if (profileData?.email !== undefined && data?.user_data?.userEmail !== undefined && tblDataSnap !== undefined) {

                var checkIfOurGroupAcceptedTheEmail = checkEmails(profileData?.email, data?.user_data?.userEmail, newData)
                console.log('checkIfOurGroupAcceptedTheEmail', checkIfOurGroupAcceptedTheEmail)
                if (checkIfOurGroupAcceptedTheEmail) {
                    setRpMode(rolePlayModalType.NOMINATEPRESENTER);
                } else {
                    return
                }

            }

        }

        if (data?.type === 'live_session') {
            if (data?.sub_type === 'time_extend') {
                console.log(data, "extending111111111111111111111111111111!!!!!!!!!!!!!!!")
                setTimeExtended(true)
                //
            }
        }
        if (data?.type === 'role_play') {
            if (data?.sub_type === 'roleplay_join_table') {
                const isMyEmailParticipant = data.participantsList.some((participant: { participant_email: any; }) => participant.participant_email === profileData?.email);
                const trainerDetail = data.participantsList.find((participant: { isTrainer: any; }) => participant.isTrainer == true);
                trainerDetail.participant_email = 'trainer@vtt'
                if (isMyEmailParticipant) {
                    setTblData((prevData: any) => {
                        return { ...prevData, seats: [...prevData.seats, trainerDetail] };
                    });
                } else {
                    console.log("hello");
                }
            } else if (data?.sub_type === 'roleplay_leave_table') {
                const myGroup = data.participantsList.some(
                    (participant: any) =>
                        participant.participant_email === profileData?.email
                );

                if (myGroup) {
                    const newSeats = data.participantsList.filter(
                        (participant: any) =>
                            participant.isTrainer !== true
                    );
                    setTblData((prevData: any) => {
                        return { ...prevData, seats: newSeats };
                    });
                } else {
                    console.log('hello');
                }
            }
        }
        if (data.type == "role_play" || data.type == "launch_case_study") {
            if (data.sub_type == "reset_group_data") {
                const currentGrp = data.activityData.table_data.find((item: any) => item.table_name === "Group 1")
                const gldata = currentGrp.seats.find((item: any) => item.group_leader === true);
                setGroupleader(gldata);
                var allotedTime = data?.activityData?.alot_time;
                startTimer(Number(allotedTime))
            }
        }
        if (data?.sub_type == rolePlaySubType.END_PRESENTATION) {
            setIsPresentationStarted(false);
            setRoleplayAnalysisEnded(true)
            return
        }

        if (data.type === 'role_play') {
            if (data?.activityData == 'end_presentation') {
                setRpMode(false);
            }


        }
        // SPOTLIGHT_TABLE
        if (data?.sub_type == socketMessageSubType?.SPOTLIGHT_TABLE_SET) {
            setSpotlightTable(data?.activityData?.table)
            return
        }

        if (data?.sub_type == socketMessageSubType?.SPOTLIGHT_TABLE_UNSET) {
            setSpotlightTable({})
            return
        }

        // pre_recorded_role_play_started {"type":"role_play","sub_type":"pre_recorded_role_play_started","room_id":2877,"timestamp":140} 
        if (data?.type == socketMessageType?.ROLE_PLAY && data?.sub_type == rolePlaySubType.PRE_RECORDED_ROLE_PLAY_STARTED) {
            socketMessageSubTypeRef.current = data.sub_type;
            setIsPreRecorded(true)
            // setRecordingUrl()
            return
        }
        if (data?.type == socketMessageType?.ROLE_PLAY && data?.sub_type == rolePlaySubType.PRE_RECORDED_ROLE_PLAY_ENDED) {
            socketMessageSubTypeRef.current = data.sub_type;
            setIsPreRecorded(false)
            setRpMode(rolePlayModalType.YOU_VOLUNTEER);
            setShowRoleplayModal(true);
            // setRecordingUrl()
            return
        }
        if (data?.type == socketMessageType?.ROLE_PLAY && data.sub_type == rolePlaySubType.ALLOW_GROUPS_TO_VOLUNTEER) {
            console.log('line 996::::')
            setRpMode(rolePlayModalType.READY_TO_PRESENT_GROUP_LEADER)
        }

        if (socketMessageSubTypeRef?.current != rolePlaySubType.PRE_RECORDED_ROLE_PLAY_STARTED && data?.type == socketMessageType.ROLE_PLAY && data?.sub_type == rolePlaySubType.VOLUNTEER_FOR_ROLEPLAY) {
            let usersEmail = data.users
            if (usersEmail && usersEmail.length > 0) {
                if (usersEmail.includes(profileData?.email)) {
                    setRpMode(rolePlayModalType.YOU_VOLUNTEER);
                    setShowRoleplayModal(true);
                }
            } else {
                setRpMode(rolePlayModalType.YOU_VOLUNTEER);
                setShowRoleplayModal(true);
            }
            return;
        }

        if (data?.type == socketMessageType.ROLE_PLAY && data?.sub_type == rolePlaySubType.END_ROLEPLAY_ANALYSIS) {
            setRpMode(rolePlayModalType.ROLEPLAY_ANALYSIS);
            setRoleplayAnalysisEnded(true)
            //  
            setIsPreRecorded(false)
            setPrivateRoomData([])
            setRpUsers([])
            setRpData([])
            setRpActivityData(null)
            setOpenClassInteraction(false)
            setRoleplayLaunched(false)
            setIsBriefing(false)
            roomClient?.consumerResumeAllAudio();
            return;
        }

        if (data?.type == socketMessageType.ROLE_PLAY && data?.sub_type == rolePlaySubType.SYSTEM_SELECTED_FOR_ROLEPLAY) {
            // if(data?.users === profileData?.email){
            setNewUsers(parseToJson(data.users));
            // setShouldShowisRoleplayLaunched(false);
            if (data.users) {
                let users: string[] = parseToJson(data.users);
                // Check if my (current user_email exist in this list then show me the popup)
                if (users.includes((profileData?.email))) {
                    setRoleSystemSelect(true)

                    // this is older approch and i make new modal for this


                    // setActivePopup(2);
                    //   setTimeout(() => {
                    //     setRpMode(rolePlayModalType.SYSTEM_SELECT);
                    //     setShowRoleplayModal(true);
                    //     if (isRolePlayAccepted === false) {
                    //       timer = setTimeout(() => {
                    //         setShowRoleplayModal(false);
                    //         clearTimeout(timer);
                    //         // setRpMode(rolePlayModalType.USER_NOT_RESPOND);
                    //         setShowRoleplayModal(true);
                    //         // USER NOT RESPOND
                    //         // let timer1 = setTimeout(() => {
                    //         //   clearTimeout(timer1);
                    //         //   setShowRoleplayModal(false);
                    //         // }, 1000);
                    //       }, 10000);
                    //     }
                    //   }, rpMode == rolePlayModalType.DECLINED ? 8000 :2000);
                    // } else {
                    //   console.log('someone else is selected')
                    // }
                }
            }
            // }
            // }
        }
        // user is selected as roleplayer
        if (
            data?.type == socketMessageType.ROLE_PLAY &&
            data?.sub_type == rolePlaySubType.VOLUNTEERS_SELECTED_EMAILS
        ) {

            setRpUsers(JSON.parse(data?.roleplayers))
            const activityData = data?.activity_data || data?.activityData;
            const parseActivityData = activityData? JSON.parse(activityData) : {};
            if (parseActivityData) {
            let rolesArray = [];
            if (parseActivityData?.types_of_role_play === RolePlayLaunchedType.OpenRolePlay) {
                // For Open Role Play, populate missing attachment_url from role_brief_url
                rolesArray = Array.isArray(parseActivityData?.roles)
                    ? parseActivityData.roles.map((role: any) => ({
                        ...role,
                        attachment_url: role.attachment_url || parseActivityData.role_brief_url
                    }))
                    : [{
                        ...parseActivityData.roles,
                        attachment_url: parseActivityData.roles?.attachment_url || parseActivityData.role_brief_url
                    }];

                // Also update the activityData roles
                parseActivityData.roles = rolesArray;
            } else {
                rolesArray = Array.isArray(parseActivityData?.roles)
                    ? parseActivityData.roles
                    : [parseActivityData.roles];
            }

            setRpData(rolesArray);
            setRpActivityData(parseActivityData);
            setAccessBriefCondition(parseActivityData?.share_brief);
            }
            if (
                data?.roleplayers &&
                JSON.parse(data?.roleplayers).filter(
                    (x) =>
                        x?.userEmail?.toLowerCase() ==
                        profileData?.email?.toLowerCase()
                ).length > 0
            ) {
                // Great! You have been selected as one of the Role Players!
                setRpMode(rolePlayModalType?.YOU_SELECTED);
                // if I am selected as roleplayer 
                updateSessionMetaInfo()
                setShowRoleplayModal(true);
                setTimeout(() => {
                    setShowRoleplayModal(false);
                }, 2000);
            } else {
                // Oops! Some others clicked faster, so you've missed the opportunity this time!
                setRpMode(rolePlayModalType?.OTHER_SELECTED);
                setShowRoleplayModal(true);
                setTimeout(() => {
                    setShowRoleplayModal(false);
                }, 2000);
            }
            return;
        }
        // role players are selected
        if (
            data?.type == socketMessageType.ROLE_PLAY &&
            data?.sub_type == rolePlaySubType.VOLUNTEERS_SELECTED_EMAILS
        ) {
            //user is selected as roleplayer
            if (
                data?.roleplayers &&
                JSON.parse(data?.roleplayers).filter(
                    (x) =>
                        x?.userEmail?.toLowerCase() ==
                        profileData?.email?.toLowerCase()
                ).length > 0
            ) {
                setRpMode(rolePlayModalType?.YOU_SELECTED);
                setShowRoleplayModal(true);
                setTimeout(() => {
                    setShowRoleplayModal(false);
                }, 2000);
            }
            // Oops! Some others clicked faster, so you've missed the opportunity this time!
            else {
                setRpMode(rolePlayModalType?.OTHER_SELECTED);
                setShowRoleplayModal(true);
                setTimeout(() => {
                    setShowRoleplayModal(false);
                }, 2000);
            }
            return;
        }
        // trainer selected participents for role play

        if (data.type === socketMessageType.ROLE_PLAY &&
            data.sub_type === rolePlaySubType.TRAINER_SELECTED_FOR_ROLEPLAY &&
            data.users &&
            parseToJson(data.users).some((x: any) => x === profileData?.email)) {
            setRpMode(rolePlayModalType.YOU_NOMINATED);
            setShowRoleplayModal(true);
        }
        if (
            data?.type == socketMessageType.ROLE_PLAY &&
            data?.sub_type == rolePlaySubType.ROLE_PLAYER_SWAPPING
        ) {
            setShowRpSwapModal(true);
            setRpUsers(JSON.parse(data?.users));
            const activityData = data?.activity_data || data?.activityData;
            const parseActivityData = activityData? JSON.parse(activityData) : {};
            if (parseActivityData) {
                let rolesArray = [];
                if (parseActivityData?.types_of_role_play === RolePlayLaunchedType.OpenRolePlay) {
                    // For Open Role Play, populate missing attachment_url from role_brief_url
                    rolesArray = Array.isArray(parseActivityData?.roles)
                        ? parseActivityData.roles.map((role: any) => ({
                            ...role,
                            attachment_url: role.attachment_url || parseActivityData.role_brief_url
                        }))
                        : [{
                            ...parseActivityData.roles,
                            attachment_url: parseActivityData.roles?.attachment_url || parseActivityData.role_brief_url
                        }];

                    // Also update the activityData roles
                    parseActivityData.roles = rolesArray;
                } else {
                    rolesArray = Array.isArray(parseActivityData?.roles)
                        ? parseActivityData.roles
                        : [parseActivityData.roles];
                }

                setRpData(rolesArray);
                setRpActivityData(parseActivityData);
                setAccessBriefCondition(parseActivityData?.share_brief);
            }
            setTimeout(() => {
                setShowRpSwapModal(false);
            }, 3000);
            return;
        }
        //brefing start
        if (
            data?.type == socketMessageType.ROLE_PLAY &&
            data?.sub_type == rolePlaySubType.ROLEPLAY_BRIEFING_STARTED
        ) {
            setPrivateRoomData({});
            setPrivateRoomUsers([]);
            // setShowRoleName(data.activity_data.show_role_name)
            // console.log(data.activity_data.show_role_name, "show_role_namellll")
            // FOR ONLY ROLE PLAYERS TO VIEW PDF
            // if (data.activity_data.types_of_role_play == RolePlayLaunchedType.ClosedRolePlay) {
            //   setClosedBrief(data.activity_data.share_brief)
            // }
            if (data.activity_data.types_of_role_play != RolePlayLaunchedType.InstantVerbalBriefRolePlay) {
                setClosedBrief(data.activity_data.share_brief)
            }
            setRpUsers(JSON.parse(data?.users)); //////////////////////rp 2 user
            const activityData = data?.activity_data || data?.activityData;
            const parseActivityData = activityData? JSON.parse(activityData) : {};
            if (parseActivityData) {
                let rolesArray = [];
                if (parseActivityData?.types_of_role_play === RolePlayLaunchedType.OpenRolePlay) {
                    // For Open Role Play, populate missing attachment_url from role_brief_url
                    rolesArray = Array.isArray(parseActivityData?.roles)
                        ? parseActivityData.roles.map((role: any) => ({
                            ...role,
                            attachment_url: role.attachment_url || parseActivityData.role_brief_url
                        }))
                        : [{
                            ...parseActivityData.roles,
                            attachment_url: parseActivityData.roles?.attachment_url || parseActivityData.role_brief_url
                        }];

                    // Also update the activityData roles
                    parseActivityData.roles = rolesArray;
                } else {
                    rolesArray = Array.isArray(parseActivityData?.roles)
                        ? parseActivityData.roles
                        : [parseActivityData.roles];
                }

                setRpData(rolesArray);
                setRpActivityData(parseActivityData);
                setAccessBriefCondition(parseActivityData?.share_brief);
            }
            setShowRoleplayModal(false);
            setIsBriefing(true);
            return;
        }

        if (
            data?.type == socketMessageType.ROLE_PLAY &&
            data?.sub_type == rolePlaySubType.ROLEPLAY_BRIEFING_STARTED && data.step == 'closed_briefing'
        ) {
            setPrivateRoomData({});
            setPrivateRoomUsers([]);
            setOpenPrivatRoom(false);
            setShouldShowOpenPrivatRoom(true);
            roomClient.consumerResumeAllAudio();
        }
        //common brefing start
        if (
            data?.type == socketMessageType.ROLE_PLAY &&
            data?.sub_type == rolePlaySubType.COMMON_BRIEFING_STARTED
        ) {
            setRpUsers(JSON.parse(data?.users))
            const activityData = data?.activity_data || data?.activityData;
            const parseActivityData = activityData ? JSON.parse(activityData) : {};
            if (parseActivityData) {
                let rolesArray = [];
                if (parseActivityData?.types_of_role_play === RolePlayLaunchedType.OpenRolePlay) {
                    // For Open Role Play, populate missing attachment_url from role_brief_url
                    rolesArray = Array.isArray(parseActivityData?.roles)
                        ? parseActivityData.roles.map((role: any) => ({
                            ...role,
                            attachment_url: role.attachment_url || parseActivityData.role_brief_url
                        }))
                        : [{
                            ...parseActivityData.roles,
                            attachment_url: parseActivityData.roles?.attachment_url || parseActivityData.role_brief_url
                        }];

                    // Also update the activityData roles
                    parseActivityData.roles = rolesArray;
                } else {
                    rolesArray = Array.isArray(parseActivityData?.roles)
                        ? parseActivityData.roles
                        : [parseActivityData.roles];
                }

                setRpData(rolesArray);
                setRpActivityData(parseActivityData);
                setAccessBriefCondition(parseActivityData?.share_brief);
            }
            setShowRoleplayModal(false);
            // setIsCommonBriefing(true)
            return;
        }
        if (data.sub_type === 'role_play' && data.sub_type === 'volunteer_for_roleplay') {
            if (data.users.length === 0) {
                console.log('No one volunteered bye');

                dispatch(
                    updateSessionSettings({
                        systemMute: true,
                        micState: 'systemMuted'
                    })
                );
            }
        }
        // if (data?.type == rolePlaySubType.UNMUTE_PARTICIPANT) {
        //     setUnMuteParticipant(data)
        // }
        if (data?.type == rolePlaySubType.OPEN_PRIVATE_ROOM) {
            let _userData = JSON?.parse(data?.users);
            let _useEmails = _userData?.map((u: any) => u?.userEmail);
            console.log("_useEmails ::", _useEmails)
            // if (_useEmails?.includes(profileData?.email)) {
            setPrivateRoomUsers(_userData);
            setPrivateRoomData(_userData);
            setOpenPrivatRoom(true);
            setShouldShowOpenPrivatRoom(false);
            // }
        }
        // debrief flow
        if (data?.type == socketMessageType.SPLIT_ROOM) {
            // split group and set up table name and team leader name
            getTableName(data?.newGroups?.table);
            return
        }

        // startroleplay
        if (data?.sub_type == rolePlaySubType.ROLEPLAY_LAUNCHED) {
            setRoleplayLaunched(true)
            return
        }
        if (data?.type == "role_play" && data?.typeOfSelection == 'system_select') {
            setRpMode(rolePlayModalType.YOUSELECTEDGL)
            if (groupleaderRef?.current) {
                if (groupleaderRef?.current?.participant_email == profileData?.email) {
                    setCanTransfer(true)
                    setRpMode(rolePlayModalType?.YOUSELECTEDGL)
                }
            }
            else {
                setGroupOrder(tblDataRef?.current?.seats[0])
                if (tblDataRef?.current?.seats[0]?.participant_email == profileData?.email) {
                    setCanTransfer(true)
                    setRpMode(rolePlayModalType?.YOUSELECTEDGL)
                }
            }
            return
        }

        if (data?.type == "role_play" && data?.typeOfSelection == 'each_group_nominate') {
            // each group picks their own GL
            setIsGlTransfer(false)
            setRpMode(rolePlayModalType?.NOMINATEGL)
            return
        }

        // flow when I am receiving this due to transfer -> I will not see transfer button. Applicable for system select only since in other modes, transfer mode is not applicable.
        if (data?.sub_type == rolePlaySubType?.SELECT_GROUP_LEADER_EACH_GM && data?.activityData[0]?.selectedParticipant) {
            console.log('Flow for nominate for transfer::::', data)
            setGroupleader(data?.activityData[0]?.selectedParticipant)
            if (data?.activityData[0]?.selectedParticipant?.participant_email == profileData?.email) {
                setCanTransfer(false)
                setRpMode(rolePlayModalType.YOUSELECTEDGL)
            } else {
                // if I am not tell others than viliyo/trainer has been selected as GL in my group
                setMessageCxt({ visible: true, message: `Viliyo has randomly selected ${data?.activityData[0]?.selectedParticipant?.participant_name} as your Group Leader!` })
            }
            return;
        }
        // flow when I accept being a group leader.
        if (data?.sub_type == rolePlaySubType?.SELECT_GROUP_LEADER_EACH_GM) {
            console.log("tblDataRef?.current :", tblDataRef?.current)
            setGroupleader(data?.activityData?.selectedMail);
            if (data?.activityData?.selectedMail == profileData?.email) {
                setCanTransfer(false)
                setRpMode(rolePlayModalType.YOUSELECTEDGL)
            } else {
                // console.log('tblDataRef?.current?.table_name:::', tblDataRef?.current?.table_name, 'data?.activityData?.table_name:::', data?.activityData?.table_name)
                // check if this change is for my group
                if (getGroupName(data?.activityData?.table_name) == getGroupName(tblDataRef?.current?.table_name)) {
                    // if I am not tell others than viliyo/trainer has been selected as GL in my group
                    setMessageCxt({ visible: true, message: `Viliyo has randomly selected ${data?.activityData?.selectedName} as your Group Leader!` })
                } else {
                    // ignore. This is for someone else.
                }
            }
            return
        }
        // never used. legacy code.
        if (data?.sub_type == rolePlaySubType.LAUNCH_CASE_STUDY) {
            // In existing groups
            if (data?.activityData?.select_the_participant_grouping == 1) {
                inExistingGroup(data?.activityData?.case)
            }
            setRpMode(rolePlayModalType.COMMENCE)
            setTimeout(() => {
                setRpMode(undefined);
            }, 2000);
            return
        }
        // {"type":"role_play","sub_type":"volunteer_for_roleplay","room_id":3008,"timestamp":151}
        if (data?.sub_type == rolePlaySubType.ALLOW_GROUPS_TO_VOLUNTEER) {
            setBriefMode("volunteer_mode")
            // show volunteer modal :: if group have leader to group leader else show to all participent
            if (groupleaderRef.current) {
                if (groupleaderRef.current?.participant_email == profileData?.email) {
                    // show volunteer modal to team leader
                    setRpMode(rolePlayModalType?.READY_TO_PRESENT_GROUP_LEADER);
                }
                else {
                    // show wait modal to other participent
                    setRpMode(rolePlayModalType?.WAIT);
                }
            } else {
                // show volunteer modal to all participent
                setRpMode(rolePlayModalType?.READY_TO_PRESENT_ALL);
            }
            return
        }

        if (data?.sub_type == rolePlaySubType.SELECTED_GROUP_ORDER) {
            if (data?.step === "presention_by_order_started") {
                setRpMode('SHOW_RANK_ORDER_FOR_PRESENTATION');
                setIsRenderPrgoress(false);
            }
            setBriefMode("order_presentation_mode")

            if (data?.groupOrder?.length > 0) {
                console.log('presentation :::::::::::::::::::!3 length is graeater than zero:::::::');

                // case 1:-- show rank order popup to all participants:-->>
                const findParticipantByEmail = (email) => {
                    for (var i = 0; i < data.groupOrder.length; i++) {
                        var group = data.groupOrder[i];
                        for (var j = 0; j < group.seats.length; j++) {
                            if (group.seats[j].participant_email === email) {
                                // group.seats[j]
                                console.log('presentationOrder::::::::::::,,1', group.seats[j])
                                //
                                dispatch({
                                    type: 'RP_ROLE_PLAY_PARTICIPANTS',
                                    payload: {
                                        rpSelectedTraineeForPresentation: group.seats[j],
                                    }
                                })
                                console.log('presentationOrder::::::::::::,,1b', group.seats[j])
                                return { groupName: group.group_name, index: i };
                            }
                        }
                    }
                    return null; // If participant not found
                }

                var participantEmail = profileData?.email;
                var result = findParticipantByEmail(participantEmail);
                if (result) {
                    console.log("Participant found in group:", result.groupName, "at index:", result.index);
                    // create case to show the rank order:------
                    setPresentationOrder({
                        ...presentationOrder,
                        groupName: result.groupName,
                        rankOrder: String(result.index),
                        presenterGroup: data?.groupGoingToPresent,
                    })
                    let groupPresentationData = data.groupOrder
                    const emailToCheck = profileData?.email;
                    const showPopUp = groupPresentationData.some((group: any) =>
                        !group.presentationDone &&
                        group.seats.some((seat: any) => seat.participant_email === emailToCheck)
                    );
                    if (showPopUp) {
                        setRpMode('SHOW_RANK_ORDER_FOR_PRESENTATION');
                    }
                } else {
                    console.log("Participant not found.");
                }
                return
            }
            // nominees are not selected : nomination flow
            if (groupleaderRef.current) {
                if (groupleaderRef.current?.participant_email == profileData?.email) {
                    // show volunteer modal to team leader
                    setRpMode(rolePlayModalType?.READY_TO_PRESENT_GROUP_LEADER);
                }
                else {
                    // show wait modal to other participent
                    setRpMode(rolePlayModalType?.WAIT);
                }
            } else {
                // show volunteer modal to all participent
                setRpMode(rolePlayModalType?.READY_TO_PRESENT_ALL);
            }
            return
        }


        if (data.type == "role_play") {
            if (data.sub_type == rolePlaySubType.SELECTED_GROUP_ORDER) {
                setGroupOrder([...data?.groupOrder]);
                setRpMode(rolePlayModalType.GROUPORDER)
            }
        }

        if (data?.sub_type == rolePlaySubType.ASK_GROUP_TO_PRESENT_PRESENATION) {
            setIsRenderPrgoress(false);
            setRoleplayAnalysisEnded(false)
            //Setting redux value
            const participant = data.activity_data.seats.find((seat: any) => seat.participant_email === profileData?.email);
            dispatch({
                type: 'RP_ROLE_PLAY_PARTICIPANTS',
                payload: {
                    rpSelectedTraineeForPresentation: participant,
                }
            })


            if (data?.activity_data?.selected_nominee?.selectedNom_email == profileData?.email) {
                // trainee have to present
                // setRpMode(rolePlayModalType?.STARTPRESENTATION)
                setRpMode('SELECTION_OF_GROUP_REPRESENTATION_BY_PARTICIPANTS');

            }
            return
        }


        if (data?.sub_type == rolePlaySubType.DRAG_SELECTED_GROUP_ORDER) {
            // re arrange group order
            setGroupOrder([...data?.activityData?.groupOrderListByTrainer]);
            setRpMode(rolePlayModalType?.GROUPORDER);
            return
        }


        if (data?.sub_type == rolePlaySubType?.OPEN_CLASS_INTERACTION) {
            // open class intereaction
            // setOpenClassInteraction(true)
            // setRpMode(undefined);
            // return
            console.log("timeForOC1111111111111111111", data)
            setRpMode('OPEN_CLASS_INTERACTION_IN_PROGRESS');
            setMinutes(data?.timeForOCI)
            setRoleplayAnalysisEnded(false)
            setIsRenderPrgoress(false);
            setOpenPrivatRoom(false)
            return
        }

        if (data?.sub_type == 'end_open_class_interaction') {
            setRpMode(false);
            setRoleplayAnalysisEnded(true)
            return
        }

        if (data?.sub_type == 'share_white_board') {
            // share white board
            setRpMode(undefined);
            return
        }

        if (data?.type === 'role_play') {
            if (data?.sub_type === 'launch_presentation_screen') {
                if (data?.activityData?.action === 'start_own_presentation') {
                    setRpMode('WHEN_GROUP_IS_PRESENTING_MANAULLY');
                }
            }
        }

        if (data?.activityData?.action === 'end_own_presentation' && data?.activityData?.trainee?.participant_email !== undefined) {
            console.log('end own presentation')
            setRemovedEmail(data?.activityData?.trainee?.participant_email);
            setRpMode("SELECTION_OF_GROUP_REPRESENTATION_BY_PARTICIPANTS");


            // check if the  data?.activityData?.trainee?.participant_email is in our group or not???
            console.log('tbldata::::::::::::::tblDAta:::::::', tblData);


            if (typeof tblData === 'object' && Array.isArray(tblData)) {
                var newData = tblData;
            } else if (typeof tblData === 'object') {
                var newData = [tblData];
            } else {
                console.log('newData is neither an object nor an array');
            }


            const checkEmails = (email1, email2, newData) => {
                for (let i = 0; i < newData.length; i++) {
                    const group = newData[i];
                    const seats = group?.seats;
                    let email1Found = false;
                    let email2Found = false;

                    for (let j = 0; j < seats.length; j++) {
                        const participant = seats[j];
                        //
                        if (participant.participant_email === email1) {
                            email1Found = true;
                        }
                        else if (participant.participant_email === email2) {
                            email2Found = true;
                        }
                    }
                    if (email1Found === true) {
                        if (email2Found == true) {
                            return true;
                        }
                    }

                    if (email2Found === true) {
                        if (email1Found == true) {
                            return true;
                        }
                    }
                }
                return false;
            }



            if (profileData?.email !== undefined && data?.activityData?.trainee?.participant_email !== undefined && tblDataSnap !== undefined) {

                var checkIfOurGroupAcceptedTheEmail = checkEmails(profileData?.email, data?.activityData?.trainee?.participant_email, newData)
                // console.log('checkIfOurGroupAcceptedTheEmail', checkIfOurGroupAcceptedTheEmail)
                if (checkIfOurGroupAcceptedTheEmail) {

                    setRpMode('SELECTION_OF_GROUP_REPRESENTATION_BY_PARTICIPANTS');
                    setPresentationOrder({
                        ...presentationOrder,
                        traineeDetails: data?.activityData?.trainee,
                        isOurGroupIsGoingToRepresent: true
                    })
                } else {
                    setRpMode('SELECTION_OF_GROUP_REPRESENTATION_BY_PARTICIPANTS');
                    setPresentationOrder({
                        ...presentationOrder,
                        traineeDetails: data?.activityData?.trainee,
                        isOurGroupIsGoingToRepresent: false
                    })
                    return
                }
            }

        }
        if (data?.sub_type == rolePlaySubType?.LAUNCH_PRESENTATION_SCREEN) {


            if (data?.activityData?.action === 'start_own_presentation' && data?.activityData?.trainee?.participant_email !== undefined) {
                console.log('start own presentation')

                setRemovedEmail(data?.activityData?.trainee?.participant_email);
                setRpMode('WHEN_GROUP_IS_PRESENTING');
                setPresentationOrder({
                    ...presentationOrder,
                    traineeDetails: data?.activityData?.trainee
                })
            }

            if (data?.activityData?.action === 'end_own_presentation' && data?.activityData?.trainee?.participant_email !== undefined) {
                console.log('end own presentation')
                setRemovedEmail(data?.activityData?.trainee?.participant_email);

                // check if the  data?.activityData?.trainee?.participant_email is in our group or not???
                console.log('tbldata::::::::::::::tblDAta:::::::', tblData);


                if (typeof tblData === 'object' && Array.isArray(tblData)) {
                    var newData = tblData;
                } else if (typeof tblData === 'object') {
                    var newData = [tblData];
                } else {
                    console.log('newData is neither an object nor an array');
                }


                const checkEmails = (email1, email2, newData) => {
                    for (let i = 0; i < newData.length; i++) {
                        const group = newData[i];
                        const seats = group?.seats;
                        let email1Found = false;
                        let email2Found = false;

                        for (let j = 0; j < seats.length; j++) {
                            const participant = seats[j];
                            //
                            if (participant.participant_email === email1) {
                                email1Found = true;
                            }
                            else if (participant.participant_email === email2) {
                                email2Found = true;
                            }
                        }
                        if (email1Found === true) {
                            if (email2Found == true) {
                                return true;
                            }
                        }

                        if (email2Found === true) {
                            if (email1Found == true) {
                                return true;
                            }
                        }
                    }
                    return false;
                }



                if (profileData?.email !== undefined && data?.activityData?.trainee?.participant_email !== undefined && tblDataSnap !== undefined) {

                    var checkIfOurGroupAcceptedTheEmail = checkEmails(profileData?.email, data?.activityData?.trainee?.participant_email, newData)
                    // console.log('checkIfOurGroupAcceptedTheEmail', checkIfOurGroupAcceptedTheEmail)
                    if (checkIfOurGroupAcceptedTheEmail) {

                        setRpMode('SELECTION_OF_GROUP_REPRESENTATION_BY_PARTICIPANTS');
                        setPresentationOrder({
                            ...presentationOrder,
                            traineeDetails: data?.activityData?.trainee,
                            isOurGroupIsGoingToRepresent: true
                        })
                    } else {
                        setRpMode('SELECTION_OF_GROUP_REPRESENTATION_BY_PARTICIPANTS');
                        setPresentationOrder({
                            ...presentationOrder,
                            traineeDetails: data?.activityData?.trainee,
                            isOurGroupIsGoingToRepresent: false
                        })
                        return
                    }
                }

            }

        }

        if (data?.sub_type == rolePlaySubType?.ROLEPLAY_SETUP && data?.activityData?.isSetupProcess) {
            setRpMode(rolePlayModalType.ENDWAIT);
        }

        if (data?.sub_type == rolePlaySubType?.END_PRESENTATION) {
            roomClient.disableShare() // stop sharing user's screen
            setRpMode(undefined)
            return
        }
        // - - - - - - - - - - - - - - - - - -

        if (data?.sub_type == rolePlaySubType.HANDLE_TRAINER_RESPONSE_ONEXTEND) {
            console.log('coming next group :::::::::::', data);
            if (data?.activityData?.comingGroup?.group_name == tblDataRef?.current?.table_name) {
                if (data?.activityData?.comingGroup?.selected_nominee?.selectedNom_email == profileData?.email) {
                    console.log('Coming group match found');
                    // trainer has extended response means I must be seeing the pop-up you have two minutes to wrap your presentation. Hence remove that pop-up and show new one.
                    setRpMode(rolePlayModalType?.TRAINER_HAS_EXTENDED_TIME)
                    // selectedNom_email
                }
                else {
                    console.log('Coming group match not found')
                    setRpMode(undefined);// set this to undefined since for other groups ( for which presentation is not going on, this has to be reset)
                }
            }
            return
        }

        if (data?.sub_type == rolePlaySubType.TIME_ABOUT_TO_OVER) {
            console.log('coming next group :::::::::::', data);
            console.log('time about to over::::', data?.activityData?.comingGroup?.selected_nominee?.selectedNom_email, profileData?.email,)
            if (data?.activityData?.comingGroup?.group_name == tblDataRef?.current?.table_name) {
                if (data?.activityData?.comingGroup?.selected_nominee?.selectedNom_email == profileData?.email) {
                    console.log('Coming group match found')
                    setRpMode(rolePlayModalType?.YOUNEXT)
                }
            }
            if (data?.activityData?.currentGroup?.group_name == tblDataRef?.current?.table_name) {
                if (data?.activityData?.currentGroup?.selected_nominee?.selectedNom_email == profileData?.email) {
                    console.log('current group match found')
                    console.log('returning wrap in two:::::')
                    setRpMode(rolePlayModalType.WRAP_IN_TWO);
                }
            }
            return
        }



        if (data?.sub_type == 'leader_system_select') {
            setGLMmode('leader_system_select')
            getTableName(data?.activityData || data?.groupOrder, true)
            if (groupleaderRef?.current) {
                if (groupleaderRef?.current?.participant_email == profileData?.email) {
                    setCanTransfer(true)
                    setRpMode(rolePlayModalType?.YOUSELECTEDGL)
                }
            }
            else {
                setGroupOrder(tblDataRef?.current?.seats[0])
                if (tblDataRef?.current?.seats[0]?.participant_email == profileData?.email) {
                    setCanTransfer(true)
                    setRpMode(rolePlayModalType?.YOUSELECTEDGL)
                }
            }
            return
        }

        if (data?.sub_type == 'leader_each_select') {
            // each groups picks their own GL
            setGLMmode('leader_each_select')
            setIsGlTransfer(false)
            setRpMode(rolePlayModalType?.NOMINATEGL)
            return

        }

        if (data?.sub_type == 'leader_trainer_select') {
            setGLMmode('leader_trainer_select');
            getTableName(data?.activityData?.case || data?.groupOrder, true)
            // setRpMode(false)
            return
        }
        if (data?.sub_type == rolePlaySubType.CONFIRM_EACH_GROUP_PICKS_GL) {
            const glSelectionData: any[] = data?.activityData?.selected_leader_each;
            const amIGL = glSelectionData?.find(item => item.email == profileData?.email || item.participant_email == profileData?.email)
            if (amIGL) {
                setGroupleader(amIGL);
                console.log('I am selected GL')
                // if I am part of the GL list notify that I have been selected. 
                if (groupleaderRef?.current?.participant_email == profileData?.email || groupleaderRef?.current?.email == profileData?.email) {
                    // If i was already GL, don't do anything.
                    setRpMode(rolePlayModalType?.YOUSELECTEDGL);
                    setCanTransfer(false);
                    console.log('I was already GL. Not doing anything')
                } else {
                    setRpMode(rolePlayModalType?.YOUSELECTEDGL);
                    setCanTransfer(false);
                }
            } else {
                console.log('I am not selected GL')
                // tell that some X user has been nominated as GL.
                // const isGLUnChanged = glSelectionData.find(item => item.email == groupleaderRef?.current?.participant_email || item.participant_email == groupleaderRef?.current?.participant_email)
                // if(isGLUnChanged){
                //   console.log('GL is unchanged. Doing nothing');

                //   // if last GL and new GL for my group are same don't do anything
                // } else {
                // show that some X user is selected as GL table_name
                console.log('tblData?.table_name:::', tblDataRef.current?.table_name,)
                let myGroupGl = glSelectionData.find(selected => getGroupName(selected.table_name) == getGroupName(tblDataRef.current?.table_name));
                console.log('myGroupGl::::', myGroupGl)
                if (myGroupGl) {
                    setGroupleader(myGroupGl);
                    setMessageCxt({
                        visible: true,
                        message: `You have nominated and selected ${myGroupGl?.name || myGroupGl?.participant_name} as your Group Leader!`
                    })
                }
                // }
            }
            return;
        }

        if (data.type === socketMessageType.ROLE_PLAY &&
            data.sub_type === rolePlaySubType.TRAINER_SELECTED_FOR_ROLEPLAY &&
            data.byChangeRolePlayer === false) {
            const filterData = JSON.parse(data.users)
            const hasUser = filterData.some((obj: any) => obj.userEmail == profileData?.email);
            if (hasUser) {
                setRpMode(rolePlayModalType.YOU_NOMINATED);
                setShowRoleplayModal(true);
                return
            }
        }
        // else {
        //     const filterData = JSON.parse(data.users)
        //     const hasUser = filterData.some((obj: any) => obj == profileData?.email);
        //     if (hasUser) {
        //         return
        //     }
        // }
    };

    let _activity_data = parseToJson(activityData?.activity_data);

    const renderOpenClassInteraction = () => {
        let _allParticipants = batchData?.participants;
        console.log("_allParticipants", _allParticipants);


        if (_allParticipants?.length <= 2) {
            return (
                <div className="flex flex-col h-full w-full">
                    {_allParticipants?.map((v: any, i: number) => (
                        <div key={i} className="flex-1 relative">
                            <PeerView
                                key={`oci-${v?.email}`}
                                caller="CaseStudy"
                                logicalMute={false}
                                style={{ flex: 1, height: '100%', width: '100%' }}
                                streamURL={processedStreams[v?.email]}
                            />
                            <ParticipantNew
                                userData={v}
                                name={v.participant_name}
                                id={v.participant_id}
                                profilePhoto={v.profilePhoto}
                                size="5"
                                radius="small"
                                kebab={true}
                                video="yes"
                                audio="yes"
                                streamArray={processedStreams[v?.email]}
                                isVideoOn={processedStreams[v?.email || v?.participant_email] ? true : false}
                            />
                            <div className="absolute top-0 left-0 p-2">
                                <Text className="text-white font-[Lato-Regular] text-sm bg-[rgba(0,0,0,0.5)] px-2 py-1 rounded">
                                    {v?.participant_name}
                                </Text>
                            </div>
                        </div>
                    ))}
                </div>
            );
        } else {
            return (
                <div className="relative h-full w-full">
                    {/* Role Play Debrief Banner */}
                    <div
                        className="absolute bg-[#545455] w-[60%] rounded-xl h-10 flex items-center justify-center"
                        style={{ top: '-130%', left: '20%' }}
                    >
                        <div className="flex items-center space-x-2">
                            <span className="text-[#E9BE50] text-center text-sm font-[Lato-Regular]">
                                Role Play debrief in progress
                            </span>
                            <span className="text-green-500 text-2xl">●</span>
                        </div>
                    </div>

                    {/* Duration Banner */}
                    <div
                        className="absolute bg-[#5B5D6B] w-[40%] rounded-xl h-10 flex items-center justify-center"
                        style={{ top: '-110%', left: '30%' }}
                    >
                        <span className="text-[#E9BE50] text-center text-sm font-[Lato-Regular]">
                            {_activity_data?.duration} Min Remaining
                        </span>
                    </div>

                    <div className="grid grid-cols-2  h-full w-full">
                        {_allParticipants?.map((v, i) => (
                            <div
                                key={i}
                                className="relative"
                                style={{ height: boxSize.height, width: boxSize.width }}
                            >
                                <PeerView
                                    key={`oci-grid-${v?.email}`}
                                    caller="CaseStudy"
                                    logicalMute={false}
                                    style={{ flex: 1, height: '80%', width: '100%' }}
                                    streamURL={processedStreams[v?.email]}
                                />
                                <div className="absolute bottom-0 left-0 w-full h-[15%] bg-[rgba(20,20,21,0.6)] p-2 rounded-b">
                                    <span className="text-white font-[Lato-Regular] text-base text-center block">
                                        {v?.participant_name}
                                    </span>
                                </div>
                            </div>
                        ))}
                    </div>

                    {/* Control Buttons or Draggable Component */}
                    {!isExpandedTabel && !isUsersDragableCompOpen ? (
                        <div
                            className="flex items-center bg-[rgba(84,84,85,0.8)] absolute h-12 w-1/2 bottom-[-53vh] right-5 z-[999] px-2 space-x-3"
                        >
                            <button onClick={() => setIsUsersDragableCompOpen(true)}>
                                <img
                                    src={plussquare}
                                    alt="Plus Square"
                                    className="h-8 w-8 object-contain"
                                />
                            </button>
                            <button onClick={() => setIsUsersDragableCompOpen(true)}>
                                <img
                                    src={maximize}
                                    alt="Maximize"
                                    className="h-8 w-8 object-contain"
                                />
                            </button>
                            <div className="flex-1" />
                            <button onClick={() => { }}>
                                <img
                                    src={mico}
                                    alt="Mic"
                                    className="h-6 w-6 object-contain"
                                />
                            </button>
                        </div>
                    ) : (
                        !isExpandedTabel && (
                            <div className="absolute bottom-[-28vh] left-[55%] z-[999]">
                                <Draggable defaultPosition={{ x: 0, y: 0 }}>
                                    <div className="bg-[rgba(84,84,85,0.8)] h-[24.5vh] w-[40vw] rounded-lg overflow-hidden flex flex-col">
                                        <div className="flex-1">
                                            <MyPeerView
                                                style={{ height: '22vh', width: '40vw' }}
                                                draggable={false}
                                                x={0}
                                                y={0}
                                            />
                                        </div>
                                        <div className="h-[3vh] w-[40vw] flex items-center justify-center">
                                            <span className="text-white w-[33vw] text-center text-sm font-[Lato-Regular]">
                                                {profileData?.name}
                                            </span>
                                            <button onClick={() => { }}>
                                                <img
                                                    src={mico}
                                                    alt="Mic"
                                                    className="h-6 w-6 object-contain"
                                                />
                                            </button>
                                        </div>
                                        {/* Top Control Buttons */}
                                        <div className="flex justify-between absolute w-[40vw] top-2 px-2">
                                            <button onClick={() => setIsUsersDragableCompOpen(false)}>
                                                <img
                                                    src={minus}
                                                    alt="Minus"
                                                    className="h-8 w-8 object-contain"
                                                />
                                            </button>
                                            <button onClick={() => setIsUsersDragableCompOpen(false)}>
                                                <img
                                                    src={maximize}
                                                    alt="Maximize"
                                                    className="h-8 w-8 object-contain"
                                                />
                                            </button>
                                        </div>
                                    </div>
                                </Draggable>
                            </div>
                        )
                    )}
                </div>
            );
        }
    }

    const renderModalContent = () => {
        switch (rpMode) {
            case rolePlayModalType?.DECLINED:
                return (
                    <RoleplayModal
                        visible={showRoleplayModal}
                        onDecline={() => setShowRoleplayModal(false)}
                        onStart={() => rolePlayAccept()}
                        onYes={() => rolePlayAccept()}
                        type={rpMode}
                        isAccepted={isRolePlayAccepted}
                    />
                );
            case rolePlayModalType?.YOU_VOLUNTEER:
                return (
                    <RoleplayModal
                        visible={showRoleplayModal}
                        onDecline={() => setShowRoleplayModal(false)}
                        onStart={() => rolePlayAccept()}
                        onYes={() => rolePlayAccept()}
                        type={rpMode}
                        isAccepted={isRolePlayAccepted}
                    />
                );
            case rolePlayModalType?.YOU_NOMINATED:
                return (
                    <RoleplayModal
                        visible={showRoleplayModal}
                        onDecline={() => setShowRoleplayModal(false)}
                        onStart={() => rolePlayAccept()}
                        onYes={() => rolePlayAccept()}
                        type={rpMode}
                        isAccepted={isRolePlayAccepted}
                    />
                );
            case rolePlayModalType?.USER_NOT_RESPOND:
                return (
                    <RoleplayModal
                        visible={showRoleplayModal}
                        onDecline={() => setShowRoleplayModal(false)}
                        onStart={() => rolePlayAccept()}
                        onYes={() => rolePlayAccept()}
                        type={rpMode}
                        isAccepted={isRolePlayAccepted}
                    />
                );
            case rolePlayModalType?.OTHER_SELECTED:
                return (
                    <RoleplayModal
                        visible={showRoleplayModal}
                        onDecline={() => setShowRoleplayModal(false)}
                        onStart={() => rolePlayAccept()}
                        onYes={() => rolePlayAccept()}
                        type={rpMode}
                        isAccepted={isRolePlayAccepted}
                    />
                );
            case rolePlayModalType?.YOU_SELECTED:
                return (
                    <RoleplayModal
                        visible={showRoleplayModal}
                        onDecline={() => setShowRoleplayModal(false)}
                        onStart={() => rolePlayAccept()}
                        onYes={() => rolePlayAccept()}
                        type={rpMode}
                        isAccepted={isRolePlayAccepted}
                    />
                );
            case rolePlayModalType?.ROLEPLAY_ANALYSIS:
                return <></>;
            case rolePlayModalType?.SETUP:
                return (
                    <RpSetup />
                );
            case rolePlayModalType.READY_TO_PRESENT_ALL:
                return (
                    <RpReadyToPresent
                        showButton={true}
                        onPress={selectVolunteerFirst}
                    />
                );
            case rolePlayModalType.READY_TO_PRESENT_GROUP_LEADER:
                return (
                    <RpReadyToPresent
                        showButton={groupleader?.participant_email === profileData?.email}
                        onPress={selectVolunteerFirst}
                    />
                );
            case rolePlayModalType.STARTPRESENTATION:
                return (
                    <RpStartPresenter
                        onPress={() => setRpMode(rolePlayModalType?.COMPLETEPREPARATION)}
                        nominationType={groupleaderRef.current ? nominationType.GROUP_LEADER : nominationType.GROUP_MEMBERS}
                    />
                );
            case rolePlayModalType.ENDWAIT:
                return (
                    <RpEndWait />
                );
            case rolePlayModalType.COMPLETEPREPARATION:
                return (
                    <RpCompletePreparation
                        onDone={onPreparationComplete}
                        setFileUrl={setFileToPresent}
                        activePresentation={(pt) => setPresentaionType(pt)}
                    />
                );
            case rolePlayModalType.WAIT:
                return (
                    <RpWait />
                );
            case rolePlayModalType.COMMENCE:
                return (
                    <RpCommence />
                );
            case rolePlayModalType.NOMINATEPRESENTER:
                return <></>;
            case rolePlayModalType.GROUPORDER:
                return <></>;
            case rolePlayModalType.YOUSELECTEDGL:
                return <></>;
            case rolePlayModalType?.NOMINATEGL:
                return (
                    <RpNominateGroupleader
                        data={tblData?.seats}
                        isGlTransfer={isGlTransfer}
                        onNominate={(nominee) => {
                            if (isGlTransfer) {
                                nominateGroupleader(nominee);
                            } else {
                                allNominateGroupleader(nominee);
                            }
                        }}
                    />
                );
            case rolePlayModalType?.RANDOMLYSELECTED:
                return (
                    <RpRandomlySelected
                        name={randomlySelected}
                        onClose={() => setRpMode(undefined)}
                        glmMode={GLMmode}
                    />
                );
            case 'SHOW_RANK_ORDER_FOR_PRESENTATION':
                return (
                    <RpPresentationRankOrder
                        showButton={true}
                        onPress={() => {
                            if (Number(presentationOrder?.rankOrder) === 0) {
                                setRpMode('SELECTION_OF_GROUP_REPRESENTATION_BY_PARTICIPANTS');
                                setPresentationOrder({
                                    ...presentationOrder,
                                    isOurGroupIsGoingToRepresent: true,
                                });
                            } else {
                                setRpMode('SELECTION_OF_GROUP_REPRESENTATION_BY_PARTICIPANTS');
                                setPresentationOrder({
                                    ...presentationOrder,
                                    isOurGroupIsGoingToRepresent: false,
                                });
                            }
                            setRoleplayAnalysisEnded(false);
                            setIsRenderPrgoress(false);
                        }}
                        groupName={presentationOrder?.groupName}
                        presentationRank={presentationOrder?.rankOrder}
                    />
                );
            case 'SELECTION_OF_GROUP_REPRESENTATION_BY_PARTICIPANTS1':
            case 'SELECTION_OF_GROUP_REPRESENTATION_BY_PARTICIPANTS':
                return manuallySelected ? (
                    <div className="flex flex-col items-center desktop:h-[50vh] h-[54vh] mobile:h-full relative px-4">
                        {/* Notification Bar */}
                        {/* <div className="w-full flex justify-center z-50 my-5">
                            <div className="bg-[rgba(33,32,37,0.8)] w-full rounded-lg py-1 px-4 border border-[rgba(84,84,85,1)] flex items-center justify-center">
                                <Text as="span" size="2" weight="bold" className="text-[rgba(233,190,80,1)]">
                                    Role Play debrief in progress
                                </Text>
                                <div className="w-[3vw]" />
                                <div className="h-[1.1vh] w-[1.1vh] rounded-full bg-[rgba(67,160,71,1)] border border-[rgba(233,190,80,1)]" />
                            </div>
                        </div> */}

                        <div className=" items-center flex justify-center mx-2 w-full my-5">
                            <div className="bg-gray-900 max-w-xs w-full px-4 w-fit py-2 rounded-xl" style={{ borderRadius: "8px", backgroundColor: "#24272C", boxShadow: "-2px -2px 4px 0 rgba(255, 255, 255, 0.25), 2px 2px 4px 0 rgba(0, 0, 0, 0.25)", }}>
                                <p className="text-white flex justify-center text-sm">
                                    {manuallySelected?.group_name || manuallySelected?.table_name }
                                </p>
                            </div>
                        </div>

                        {/* Grid Content */}
                        <div className="w-full flex flex-col h-full justify-start">
                            <div className="grid grid-cols-3 tablet:grid-cols-3 laptop:grid-cols-4 mobile:grid-cols-2 text-white mobile:gap-y-4 mobile:gap-0 gap-2 m-2">
                                {manuallySelected?.seats?.map((item) => (
                                    <Box key={item.id}>
                                        <TableElementNew
                                            hideKebab={true}
                                            elementStyle={{
                                                borderWidth: 1,
                                                borderRadius: 1,
                                                borderColor: '#D3D3D3',
                                                marginVertical: 0.4,
                                            }}
                                            onPress={() => { }}
                                            userData={item}
                                            isExpandedView={true}
                                            groupLeaderEmail={undefined}
                                        />
                                    </Box>
                                ))}
                            </div>
                        </div>

                        {/* Start Presentation Button (centered at bottom) */}
                        {profileData?.email === myEmailInPresentation?.participant_email && (
                            <div className="w-full flex justify-center mobile:mb-2 z-[999999]">
                                <button
                                    onClick={startManuallyPresentation}
                                    className="
      flex items-center justify-center gap-2 px-2
      border border-white text-white rounded-[43px]
      bg-gradient-to-br from-[#2F3339] to-[#15181C]
      shadow-custom-deep

      h-8 w-36     
      tablet:h-8 tablet:w-36
      laptop:h-8 laptop:w-36
      desktop:h-8 desktop:w-36
      largescreen:h-8 largescreen:w-36
      xxl:h-8 xxl:w-36
    "
                                >
                                    <Text as="span" size="2" weight="bold" className="text-s text-white">
                                        Start Presentation
                                    </Text>
                                    <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        width="16"
                                        height="16"
                                        viewBox="0 0 16 16"
                                        fill="none"
                                    >
                                        <g clipPath="url(#clip0_6083_4834)">
                                            <path
                                                d="M1.33203 1.33398H14.6654M5.33203 14.6673L7.9987 13.334M7.9987 13.334V11.334M7.9987 13.334L10.6654 14.6673M3.93203 11.334H12.0587C13.3254 11.334 13.992 10.6673 13.992 9.40065V1.33398H1.99203V9.40065C1.9987 10.6673 2.66536 11.334 3.93203 11.334Z"
                                                stroke="white"
                                                strokeMiterlimit="10"
                                                strokeLinecap="round"
                                                strokeLinejoin="round"
                                            />
                                            <path
                                                d="M5 7.33398L7.1 5.58065C7.26667 5.44065 7.48667 5.48065 7.6 5.66732L8.4 7.00065C8.51333 7.18732 8.73333 7.22065 8.9 7.08732L11 5.33398"
                                                stroke="white"
                                                strokeMiterlimit="10"
                                                strokeLinecap="round"
                                                strokeLinejoin="round"
                                            />
                                        </g>
                                        <defs>
                                            <clipPath id="clip0_6083_4834">
                                                <rect width="16" height="16" fill="white" />
                                            </clipPath>
                                        </defs>
                                    </svg>
                                </button>
                            </div>
                        )}
                    </div>

                ) : null;
            case 'WHEN_GROUP_IS_PRESENTING_MANAULLY':
            case 'WHEN_GROUP_IS_PRESENTING':
                return (
                    <div className="relative flex flex-col items-center desktop:h-[50vh] h-[50vh]  mobile:h-full w-full">
                        {/* Main content container */}
                        <div
                            className={`w-full overflow-hidden ${processedStreams[presentationOrder?.traineeDetails?.participant_email] ? 'flex flex-col mobile:h-full justify-center mobile:justify-between desktop:flex-row largescreen:flex-row laptop:flex-row' : 'flex flex-col'} tablet:flex-1`}
                        >
                            {processedStreams[presentationOrder?.traineeDetails?.participant_email] && (
                                <div className="mobile:w-full h-fit mobile:h-fit w-full max-w-[44rem] laptop:w-1/2 border border-[rgba(91,93,107,1)] flex items-center justify-center rounded-[1.5vh] overflow-hidden">
                                    <div className="w-full h-full  rounded-[1.5vh] overflow-hidden relative">
                                        <PeerView
                                            key={`presenting-${presentationOrder?.traineeDetails?.participant_email}`}
                                            caller="TableElement"
                                            logicalMute={false}
                                            style={{ height: 'mobile:h-[60vh]', width: '100%', position: 'relative', ObjectFit: 'cover' }}
                                            streamURL={processedStreams[presentationOrder?.traineeDetails?.participant_email]}
                                            peerEmail={presentationOrder?.traineeDetails?.participant_email}
                                            allStream={undefined}
                                            micIcon={true}
                                            isExpandedView={false}
                                            userDatax={presentationOrder?.traineeDetails}
                                            height={390}
                                        />
                                    </div>
                                </div>
                            )}

                            {/* Table grid (Right side) */}
                            <div
                                className={`mobile:w-full largescreen:max-h-[50vh]  w-fit ${processedStreams[presentationOrder?.traineeDetails?.participant_email] ? 'laptop:w-1/2' : ''
                                    } h-fit overflow-y-auto custom-scrollbar scrollbar-hide`}
                            >
                                <div className="h-full overflow-y-auto pr-2">
                                    <div
                                        className={`${processedStreams[presentationOrder?.traineeDetails?.participant_email] ? 'grid grid-cols-1' : 'grid grid-cols-6'} tablet:grid-cols-3 laptop:grid-cols-4 gap-2 m-2 text-white mobile:flex mobile:overflow-x-auto mobile:gap-4 mobile:px-2 mobile:pb-2 mobile:grid-cols-none mobile:grid-rows-none`}
                                    >
                                        {manuallySelected?.seats?.map((item) => {
                                            if (item?.participant_email === removedEmail) return null;
                                            return (
                                                <div key={item.participant_id}>
                                                    <TableElementNew
                                                        elementStyle={{
                                                            borderWidth: 1,
                                                            borderRadius: 1,
                                                            borderColor: '#D3D3D3',
                                                            marginVertical: 0.4,
                                                        }}
                                                        onPress={() => { }}
                                                        userData={item}
                                                        isExpandedView={true}
                                                        hideKebab={true}
                                                        groupLeaderEmail={undefined}
                                                    />
                                                </div>
                                            );
                                        })}
                                    </div>
                                </div>
                            </div>
                        </div>

                        {/* Fixed End Presentation Button */}
                        {profileData?.email === removedEmail && (
                            // <div className="absolute bottom-0 w-full flex justify-center pb-2">
                            //     <button
                            //         onClick={() => {
                            //             EndPresentation();
                            //         }}
                            //         className="bg-[rgba(224,71,37,1)] h-[5.5vh] w-[40vw] flex items-center justify-center rounded-[2.75vh] border-[1px] border-white"
                            //     >
                            //         <Text as="span" size="2" weight="bold" className="text-white">
                            //             End Presentation
                            //         </Text>
                            //     </button>
                            // </div>
                            <div className=" mobile:static absolute -bottom-10 w-full flex justify-center mobile:mb-2 z-[999999]">
                                <button
                                    onClick={() => {
                                        EndPresentation();
                                    }}
                                    className="
      flex items-center justify-center gap-2 px-2
      border border-white text-white rounded-[43px]
      bg-gradient-to-br from-[#2F3339] to-[#15181C]
      shadow-custom-deep

      h-8 w-36     
      tablet:h-8 tablet:w-36
      laptop:h-8 laptop:w-36
      desktop:h-8 desktop:w-36
      largescreen:h-8 largescreen:w-36
      xxl:h-8 xxl:w-36
    "
                                >
                                    <Text as="span" size="2" weight="bold" className="text-s text-white">
                                        Stop Presentation
                                    </Text>
                                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                                        <g clip-path="url(#clip0_6083_6290)">
                                            <path d="M14.6654 1.83398H1.33203C1.0587 1.83398 0.832031 1.60732 0.832031 1.33398C0.832031 1.06065 1.0587 0.833984 1.33203 0.833984H14.6654C14.9387 0.833984 15.1654 1.06065 15.1654 1.33398C15.1654 1.60732 14.9387 1.83398 14.6654 1.83398ZM11.112 14.894C11.0254 15.0673 10.8454 15.1673 10.6654 15.1673C10.592 15.1673 10.512 15.1473 10.4454 15.114L7.9987 13.894L5.55203 15.114C5.48536 15.1473 5.40536 15.1673 5.33203 15.1673C5.15203 15.1673 4.97203 15.0673 4.88536 14.894C4.85479 14.8351 4.83639 14.7707 4.83127 14.7046C4.82616 14.6385 4.83443 14.572 4.85558 14.5091C4.87674 14.4463 4.91036 14.3883 4.95442 14.3388C4.99848 14.2892 5.05209 14.249 5.11203 14.2207L7.4987 13.0273V11.334H8.4987V13.0273L10.8854 14.2207C11.1387 14.3407 11.2387 14.6407 11.112 14.894Z" fill="#E9BE50" />
                                            <path d="M2 1.33398V9.40065C2 10.6673 2.66667 11.334 3.93333 11.334H12.0667C13.3333 11.334 14 10.6673 14 9.40065V1.33398H2ZM11.32 5.72065L9.22 7.47398C9.02667 7.63398 8.78 7.70065 8.54667 7.66065C8.30667 7.62065 8.1 7.47398 7.97333 7.26065L7.27333 6.09398L5.32 7.72065C5.22667 7.80065 5.11333 7.83398 5 7.83398C4.89665 7.83461 4.79564 7.80319 4.71088 7.74404C4.62612 7.6849 4.56177 7.60095 4.52668 7.50373C4.49159 7.40651 4.4875 7.30081 4.51495 7.20117C4.54241 7.10153 4.60007 7.01284 4.68 6.94732L6.78 5.19398C6.97333 5.03398 7.22 4.96732 7.45333 5.00732C7.69333 5.04732 7.9 5.19398 8.02667 5.40732L8.72667 6.57398L10.68 4.94732C10.7307 4.90506 10.7892 4.87324 10.8522 4.85371C10.9153 4.83417 10.9815 4.82731 11.0472 4.8335C11.1129 4.8397 11.1767 4.85884 11.235 4.88982C11.2932 4.92079 11.3448 4.96299 11.3867 5.01398C11.56 5.22732 11.5333 5.54065 11.32 5.72065Z" fill="#E9BE50" />
                                        </g>
                                        <defs>
                                            <clipPath id="clip0_6083_6290">
                                                <rect width="16" height="16" fill="white" />
                                            </clipPath>
                                        </defs>
                                    </svg>
                                </button>
                            </div>
                        )}
                    </div>
                );
            case 'WHEN_OTHER_GROUP_IS_PRESENTER':
                return <div className="flex-1" />;
            case 'OPEN_CLASS_INTERACTION_IN_PROGRESS':
                return (
                    <div className="h-full mobile:mt-0">
                        {/* <RpOpenClassInteraction
                            batchData={batchData?.participants}
                            minutesx={minutes}
                            session_id={session_id}
                        /> */}
                        <OpenClassInteraction roomClient={roomClient} tableDetails={batchData?.participants} />
                    </div>
                );
            default:
                return null;
        }
    };

    const handleEndPresentation = () => {
        if (!userInfoHandler.current) {
            userInfoHandler.current = validateAndCreateSocketIfExist(session_id, handleOnMessage, socketList);
        }
        let payload = {
            sub_type: rolePlaySubType?.END_PRESENTATION,
            type: socketMessageType?.ROLE_PLAY,
            room_id: session_id,
            timestamp: new Date()
        }
        userInfoHandler.current.sendMessage(JSON.stringify(payload));
        roomClient.disableShare() // stop sharing user's screen
        setRpMode(undefined)
    }

    const renderModalsDuringPresentation = () => {
        return (
            <></>
        )
        // switch (rpMode) {
        //     // You have next presentation coming up.
        //     case rolePlayModalType.YOUNEXT:
        //         console.log('returning you next mode');
        //         return (
        //             <NotificationDuringPresentation
        //                 imageIcon={Images.roleplay}
        //                 message={`Your group presentation next ... in 02 minutes!`}
        //                 onClose={() => setRpMode(undefined)}
        //             />
        //         );
        //     case rolePlayModalType.TRAINER_HAS_EXTENDED_TIME:
        //         return (
        //             <NotificationDuringPresentation
        //                 imageIcon={Images.roleplay}
        //                 message={`Trainer has extended your group presentation time.`}
        //                 onClose={() => setRpMode(undefined)}
        //             />
        //         );
        //     case rolePlayModalType.WRAP_IN_TWO:
        //         console.log('returning wrap in two::')
        //         return (
        //             <NotificationDuringPresentation
        //                 imageIcon={Images.roleplay}
        //                 message={`You have 02 minutes to wrap up your presentation!`}
        //                 onClose={() => { setRpMode(undefined) }}
        //             />
        //         );
        //     default:
        //         console.log('No matching default case found for presentation mode');

        // }
    }

    const renderPresentParticipent = () => {
        return (
            <div className="flex flex-col">
                <Dialog.Root open={modalVisible} onOpenChange={setModalVisible}>
                    <Dialog.Content className="fixed w-full h-full bg-black">
                        <div className="bg-[#545455] w-[60%] rounded-[12px] h-[40px] flex justify-center items-center mt-[13vh] ml-[20vw]">
                            <div className="flex items-center relative left-[30%]">
                                <Text
                                    as="span"
                                    size="3"
                                    className="text-[#E9BE50] text-center relative left-[20%]"
                                >
                                    Role Play debrief in progress
                                </Text>
                                <div className="bg-green-700 h-[1.5vh] w-[1.5vh] rounded-full border-[1px] border-[#E9BE50] absolute left-[80%]" />
                            </div>
                        </div>
                        <div className="flex flex-col items-center bg-black">
                            <div className="h-[30vh] w-[99vw] border-[1px] border-[rgba(91,93,107,1)] my-[1vh] flex justify-center items-center rounded-[1.5vh] overflow-hidden">
                                <MyPeerView
                                    style={{ height: '100%', width: '100%' }}
                                    draggable={false}
                                    x={0}
                                    y={0}
                                />
                                <div className="bg-[rgba(20,20,21,0.6)] absolute bottom-0 w-full">
                                    <Text
                                        as="span"
                                        size="4"
                                        className="text-white text-center px-[4vw] my-[1vh]"
                                    >
                                        {batchData?.participants?.name}
                                    </Text>
                                </div>
                            </div>
                            <div className="overflow-y-auto max-h-[50vh]">
                                <ul className="grid grid-cols-2 gap-2">
                                    {batchData?.participants?.map((item, index) => (
                                        <li key={item.id} className="w-[47vw] flex justify-center my-[1vh]">
                                            <TableElement
                                                elementStyle={{
                                                    borderWidth: 1,
                                                    borderRadius: 1,
                                                    borderColor: '#D3D3D3',
                                                    marginVertical: 0.4,
                                                }}
                                                onPress={() => { }}
                                                userData={item}
                                                isExpandedView={true}
                                                groupLeaderEmail={undefined}
                                                hideKebab={true}
                                            />
                                        </li>
                                    ))}
                                </ul>
                            </div>
                            <button
                                onClick={() => handleEndPresentation()}
                                className="bg-[rgba(224,71,37,1)] h-[5.5vh] w-[40vw] flex items-center justify-center rounded-[2.75vh] mb-[1.5vh] border-[1px] border-white"
                            >
                                <Text
                                    as="span"
                                    size="3"
                                    className="text-white text-center"
                                >
                                    End Presentation
                                </Text>
                            </button>
                            {/* <Footer
                                session_id={session_id}
                                consoleDetailData={consoleDetailData}
                                orientation={undefined}
                                messageCount={messageCount}
                            /> */}
                        </div>
                    </Dialog.Content>
                </Dialog.Root>
            </div>
        );
    };


    if (isPresentationStarted && ['share_whiteboard', 'case_url', 'share_screen']?.includes(presentaionData?.activePresentation) && showFullscreen) {
        return (
            <Box className="flex-1">
                {presentaionData?.activePresentation === 'share_whiteboard' && (
                    <Box className="flex-1">
                        <iframe
                            src={`https://vtt.atwpl.com/whiteboard/boards/${session_id}?disableInteraction=${presentaionData?.presentNominee === profileData?.email ? false : true
                                }`}
                            className="w-full h-full"
                            allow="camera; microphone; fullscreen; display-capture"
                        />
                    </Box>
                )}
                {presentaionData?.activePresentation === 'case_url' && (
                    <Box className="flex-1">
                        {presentaionData?.fileUrl?.endsWith('.pdf') ? (
                            <iframe src={presentaionData?.fileUrl} className="w-full h-full" />
                        ) : (
                            <iframe
                                src={`https://view.officeapps.live.com/op/embed.aspx?src=${presentaionData?.fileUrl}`}
                                className="w-full h-full"
                            />
                        )}
                    </Box>
                )}
                {presentaionData?.activePresentation === 'share_screen' && (
                    <Box className="flex-1">
                        <PeerView
                            style={{ height: '100%', width: '100%' }}
                            streamURL={shareStream}
                        // key={new Date()}
                        />
                    </Box>
                )}
                <Box className="flex flex-wrap">
                    {['share_whiteboard', 'case_url', 'share_screen']?.includes(presentaionData?.activePresentation) &&
                        presentaionData?.presentNominee !== profileData?.email && (
                            <PeerView
                                style={undefined}
                                streamURL={processedStreams[presentaionData?.presentNominee]}
                                // key={new Date()}
                            />
                        )}
                    {/* <Box><Trainer name={trainer?.fullname} trainerTableName="On Table 1" /></Box>
                    <Box><MyPeerView /></Box> */}
                </Box>
            </Box>
        );
    }

    if (isPresentationStarted) {
        return (
            <>
                <Box className="flex-1">
                    {!presentaionData?.activePresentation && (
                        <PeerView
                            style={undefined}
                            streamURL={processedStreams[presentaionData?.presentNominee]}
                        />
                    )}
                    {presentaionData?.activePresentation === 'share_whiteboard' && (
                        <Box className="h-[70vh] w-[96vw] m-[2vw]">
                            <iframe
                                src={`https://vtt.atwpl.com/whiteboard/boards/${session_id}`}
                                className="w-full h-full"
                                allow="camera; microphone; fullscreen; display-capture"
                            />
                        </Box>
                    )}
                    {presentaionData?.activePresentation === 'case_url' && (
                        <Box className="h-[70vh] w-[96vw] m-[2vw]">
                            {presentaionData?.fileUrl?.endsWith('.pdf') ? (
                                <iframe src={presentaionData?.fileUrl} className="w-full h-full" />
                            ) : (
                                <iframe
                                    src={`https://view.officeapps.live.com/op/embed.aspx?src=${presentaionData?.fileUrl}`}
                                    className="w-full h-full"
                                />
                            )}
                        </Box>
                    )}
                    {presentaionData?.activePresentation === 'share_screen' && (
                        <PeerView
                            style={undefined}
                            streamURL={shareStream}
                        />
                    )}
                    {renderPresentParticipent()}
                    {renderModalsDuringPresentation()}
                </Box>
            </>
        );
    }

    return (
        <div className="flex flex-col mobile:h-full h-full w-full">
            {/* Main container */}
            {/* <div className="flex justify-between p-4">
                <div className="w-1/4 h-32 bg-gray-200 rounded" />
            </div> */}

            {/* Main layout */}
            <div
                ref={mainLayoutRef}
                className="h-full relative"
            >
                {/* {openPrivatRoom ? null : <div className="
    w-full
    z-50
    left-1/2
    -translate-x-1/2
    absolute
    top-5
    mobile:static
    tablet:static
    mobile:left-0
    tablet:left-0
    mobile:translate-x-0
    tablet:translate-x-0
    mobile:flex
    tablet:flex
    mobile:justify-center
    tablet:justify-center
    mobile:mt-5
    tablet:mt-5
  ">
                    <Trainer videoHeight={150} videoWidth={250} name={trainer?.fullname} trainerTableName="On Table 1" />
                </div>} */}
                <div className={`relative z-0 h-full ${rpMode !== undefined ? 'mt-0' : ''}`}>
                    {/* Main content */}
                    {renderMainPart()}
                    {renderModalContent()}
                    {prensentationTimeExtendModal()}
                </div>

                {/* RoleplaySwapModal */}
                <RoleplaySwapModal
                    visible={showRpSwapModal}
                    onDecline={() => setShowRpSwapModal(false)}
                />

                {/* Role System Select Modal */}
                <Dialog.Root open={roleSystemSelect} onOpenChange={setRoleSystemSelect}>
                    <Dialog.Portal>
                        <Dialog.Overlay className="fixed inset-0 bg-black bg-opacity-50" />
                        <Dialog.Content className="fixed top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 bg-white p-6 rounded-lg shadow-lg max-w-md w-full">
                            <div className="flex flex-col items-center">
                                {/* <img
                  src={Image.roleplay}
                  alt="Roleplay"
                  className="h-12 w-12 object-contain"
                /> */}
                                <div className="absolute top-2 right-4 text-red-500">
                                    Closes in {Math.max(countdown, 0)}s
                                </div>
                                <p className="mt-4 text-center text-lg font-semibold">
                                    Hey! You have been selected as one of the Role Players!
                                </p>
                                <div className="flex space-x-4 mt-4">
                                    <button
                                        className="px-4 py-2 bg-green-600 text-white rounded hover:bg-green-700"
                                        onClick={() => {
                                            rolePlayAccept();
                                            setRoleSystemSelect(false);
                                        }}
                                    >
                                        Let’s start!
                                    </button>
                                    <button
                                        className="px-4 py-2 bg-red-600 text-white rounded hover:bg-red-700"
                                        onClick={() => {
                                            declineSystemSelect();
                                            setRpMode("DECLINED");
                                            setRoleSystemSelect(false);
                                            setTimeout(() => setRpMode(undefined), 2000);
                                        }}
                                    >
                                        I decline
                                    </button>
                                </div>
                                <p className="mt-4 text-center text-sm">
                                    You will need to keep your camera and audio enabled for the best
                                    outcome & experience
                                </p>
                            </div>
                        </Dialog.Content>
                    </Dialog.Portal>
                </Dialog.Root>

                {/* Other Clicked Modal */}
                <Dialog.Root open={otherClicked} onOpenChange={setOtherClicked}>
                    <Dialog.Portal>
                        <Dialog.Overlay className="fixed inset-0 bg-black bg-opacity-50" />
                        <Dialog.Content className="fixed top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 bg-white p-6 rounded-lg shadow-lg max-w-md w-full">
                            <div className="flex flex-col items-center">
                                {/* <img
                  src={Images.roleplay}
                  alt="Roleplay"
                  className="h-12 w-12 object-contain"
                /> */}
                                <Dialog.Close asChild>
                                    <button className="absolute top-2 right-2">
                                        <img
                                            src={xCircle}
                                            alt="Close"
                                            className="h-6 w-6 object-contain"
                                        />
                                    </button>
                                </Dialog.Close>
                                <p className="mt-4 text-center text-lg font-bold">
                                    Oops! Some others clicked faster, so you’ve missed the
                                    opportunity this time!
                                </p>
                            </div>
                        </Dialog.Content>
                    </Dialog.Portal>
                </Dialog.Root>

                {/* Other modals */}
            </div>

            {/* Bottom Message */}
            <BottomMessageWithIcon
                message={messageCxt.message}
                visible={messageCxt.visible}
                onClose={() =>
                    setMessageCxt({
                        visible: false,
                        message: "",
                    })
                }
            />

            {/* Start Presentation Button */}
            {showStartPresentation && (
                <button
                    className="fixed bottom-4 right-4 px-4 py-2 rounded-full shadow-lg"
                    style={{
                        background: "linear-gradient(to right, #697051, #92A894, #697051)",
                    }}
                    onClick={startPresentation}
                >
                    <div className="flex items-center space-x-2">
                        {/* <img
              src={Image.presentationIcon}
              alt="Presentation"
              className="h-6 w-6 object-contain"
            /> */}
                    </div>
                </button>
            )}
        </div>
    );
};
export default RolePlay;